// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%274%27 viewBox=%270 0 8 4%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M0.500009 1C3.5 1 3.00001 4 5.00001 4C7 4 6.5 1 9.5 1C10 1 10 0.499897 10 0H0C-1.99338e-08 0.5 0 1 0.500009 1Z%27 fill=%27black%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 stroke=%27black%27 viewBox=%270 0 24 24%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg transform-origin=%27center%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279.5%27 fill=%27none%27 stroke-width=%273%27 stroke-linecap=%27round%27%3E%3CanimateTransform attributeName=%27transform%27 type=%27rotate%27 from=%270 12 12%27 to=%27360 12 12%27 dur=%272s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dasharray%27 values=%270,150;42,150;42,150%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3Canimate attributeName=%27stroke-dashoffset%27 values=%270;-16;-59%27 keyTimes=%270;0.475;1%27 dur=%271.5s%27 repeatCount=%27indefinite%27/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 200 200%27%3E%3Cfilter id=%27a%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%271.34%27 numOctaves=%274%27 stitchTiles=%27stitch%27%3E%3C/feTurbulence%3E%3C/filter%3E%3Crect width=%27200%27 height=%27200%27 filter=%27url%28%23a%29%27 opacity=%270.2%27%3E%3C/rect%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.0 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: "Manrope", system-ui, sans-serif;
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-50: oklch(97.1% 0.013 17.38);
    --color-red-100: oklch(93.6% 0.032 17.717);
    --color-red-200: oklch(88.5% 0.062 18.334);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-red-600: oklch(57.7% 0.245 27.325);
    --color-red-700: oklch(50.5% 0.213 27.518);
    --color-red-800: oklch(44.4% 0.177 26.899);
    --color-orange-100: oklch(95.4% 0.038 75.164);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-amber-400: oklch(82.8% 0.189 84.429);
    --color-amber-900: oklch(41.4% 0.112 45.904);
    --color-yellow-400: oklch(85.2% 0.199 91.936);
    --color-yellow-900: oklch(42.1% 0.095 57.708);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-green-600: oklch(62.7% 0.194 149.214);
    --color-cyan-500: oklch(71.5% 0.143 215.221);
    --color-blue-50: oklch(97% 0.014 254.604);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-blue-600: oklch(54.6% 0.245 262.881);
    --color-indigo-100: oklch(93% 0.034 272.788);
    --color-indigo-500: oklch(58.5% 0.233 277.117);
    --color-indigo-600: oklch(51.1% 0.262 276.966);
    --color-purple-100: oklch(94.6% 0.033 307.174);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-pink-100: oklch(94.8% 0.028 342.258);
    --color-pink-400: oklch(71.8% 0.202 349.761);
    --color-pink-500: oklch(65.6% 0.241 354.308);
    --color-gray-100: oklch(96.7% 0.003 264.542);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-black: #000;
    --spacing: 0.25rem;
    --container-md: 28rem;
    --container-2xl: 42rem;
    --container-4xl: 56rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --radius-lg: 0.5rem;
    --animate-spin: spin 1s linear infinite;
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .diff {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      display: grid;
      width: 100%;
      overflow: hidden;
      webkit-user-select: none;
      -webkit-user-select: none;
              user-select: none;
      grid-template-rows: 1fr 1.8rem 1fr;
      direction: ltr;
      container-type: inline-size;
      grid-template-columns: auto 1fr;
      &:focus-visible, &:has(.diff-item-1:focus-visible) {
        outline-style: var(--tw-outline-style);
        outline-width: 2px;
        outline-offset: 1px;
        outline-color: var(--color-base-content);
      }
      &:focus-visible {
        outline-style: var(--tw-outline-style);
        outline-width: 2px;
        outline-offset: 1px;
        outline-color: var(--color-base-content);
        .diff-resizer {
          min-width: 95cqi;
          max-width: 95cqi;
        }
      }
      &:has(.diff-item-1:focus-visible) {
        outline-style: var(--tw-outline-style);
        outline-width: 2px;
        outline-offset: 1px;
        .diff-resizer {
          min-width: 5cqi;
          max-width: 5cqi;
        }
      }
      @supports (-webkit-overflow-scrolling: touch) and (overflow: -webkit-paged-x) {
        &:focus {
          .diff-resizer {
            min-width: 5cqi;
            max-width: 5cqi;
          }
        }
        &:has(.diff-item-1:focus) {
          .diff-resizer {
            min-width: 95cqi;
            max-width: 95cqi;
          }
        }
      }
    }
  }
  .modal {
    @layer daisyui.l1.l2.l3 {
      pointer-events: none;
      visibility: hidden;
      position: fixed;
      inset: calc(0.25rem * 0);
      margin: calc(0.25rem * 0);
      display: grid;
      height: 100%;
      max-height: none;
      width: 100%;
      max-width: none;
      align-items: center;
      justify-items: center;
      background-color: transparent;
      padding: calc(0.25rem * 0);
      color: inherit;
      transition: visibility 0.3s allow-discrete, background-color 0.3s ease-out, opacity 0.1s ease-out;
      overflow: clip;
      overscroll-behavior: contain;
      z-index: 999;
      scrollbar-gutter: auto;
      &::backdrop {
        display: none;
      }
    }
    @layer daisyui.l1.l2 {
      &.modal-open, &[open], &:target, .modal-toggle:checked + & {
        pointer-events: auto;
        visibility: visible;
        opacity: 100%;
        transition: visibility 0s allow-discrete, background-color 0.3s ease-out, opacity 0.1s ease-out;
        background-color: oklch(0% 0 0/ 0.4);
        .modal-box {
          translate: 0 0;
          scale: 1;
          opacity: 1;
        }
        :root:has(&) {
          --page-has-backdrop: 1;
          --page-overflow: hidden;
          --page-scroll-bg: var(--page-scroll-bg-on);
          --page-scroll-gutter: stable;
          --page-scroll-transition: var(--page-scroll-transition-on);
          animation: set-page-has-scroll forwards;
          animation-timeline: scroll();
        }
      }
      @starting-style {
        &.modal-open, &[open], &:target, .modal-toggle:checked + & {
          opacity: 0%;
        }
      }
    }
  }
  .tooltip {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      display: inline-block;
      --tt-bg: var(--color-neutral);
      --tt-off: calc(100% + 0.5rem);
      --tt-tail: calc(100% + 1px + 0.25rem);
      & > .tooltip-content, &[data-tip]:before {
        position: absolute;
        max-width: 20rem;
        border-radius: var(--radius-field);
        padding-inline: calc(0.25rem * 2);
        padding-block: calc(0.25rem * 1);
        text-align: center;
        white-space: normal;
        color: var(--color-neutral-content);
        opacity: 0%;
        font-size: 0.875rem;
        line-height: 1.25;
        background-color: var(--tt-bg);
        width: max-content;
        pointer-events: none;
        z-index: 2;
        --tw-content: attr(data-tip);
        content: var(--tw-content);
      }
      &:after {
        opacity: 0%;
        background-color: var(--tt-bg);
        content: "";
        pointer-events: none;
        width: 0.625rem;
        height: 0.25rem;
        display: block;
        position: absolute;
        mask-repeat: no-repeat;
        mask-position: -1px 0;
        --mask-tooltip: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        mask-image: var(--mask-tooltip);
      }
      @media (prefers-reduced-motion: no-preference) {
        & > .tooltip-content, &[data-tip]:before, &:after {
          transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1) 75ms, transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 75ms;
        }
      }
      &:is([data-tip]:not([data-tip=""]), :has(.tooltip-content:not(:empty))) {
        &.tooltip-open, &:hover, &:has(:focus-visible) {
          & > .tooltip-content, &[data-tip]:before, &:after {
            opacity: 100%;
            --tt-pos: 0rem;
            @media (prefers-reduced-motion: no-preference) {
              transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s, transform 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s;
            }
          }
        }
      }
    }
    @layer daisyui.l1.l2 {
      > .tooltip-content, &[data-tip]:before {
        transform: translateX(-50%) translateY(var(--tt-pos, 0.25rem));
        inset: auto auto var(--tt-off) 50%;
      }
      &:after {
        transform: translateX(-50%) translateY(var(--tt-pos, 0.25rem));
        inset: auto auto var(--tt-tail) 50%;
      }
    }
  }
  .menu {
    @layer daisyui.l1.l2.l3 {
      display: flex;
      width: fit-content;
      flex-direction: column;
      flex-wrap: wrap;
      padding: calc(0.25rem * 2);
      --menu-active-fg: var(--color-neutral-content);
      --menu-active-bg: var(--color-neutral);
      font-size: 0.875rem;
      :where(li ul) {
        position: relative;
        margin-inline-start: calc(0.25rem * 4);
        padding-inline-start: calc(0.25rem * 2);
        white-space: nowrap;
        &:before {
          position: absolute;
          inset-inline-start: calc(0.25rem * 0);
          top: calc(0.25rem * 3);
          bottom: calc(0.25rem * 3);
          background-color: var(--color-base-content);
          opacity: 10%;
          width: var(--border);
          content: "";
        }
      }
      :where(li > .menu-dropdown:not(.menu-dropdown-show)) {
        display: none;
      }
      :where(li:not(.menu-title) > *:not(ul, details, .menu-title, .btn)), :where(li:not(.menu-title) > details > summary:not(.menu-title)) {
        display: grid;
        grid-auto-flow: column;
        align-content: flex-start;
        align-items: center;
        gap: calc(0.25rem * 2);
        border-radius: var(--radius-field);
        padding-inline: calc(0.25rem * 3);
        padding-block: calc(0.25rem * 1.5);
        text-align: start;
        transition-property: color, background-color, box-shadow;
        transition-duration: 0.2s;
        transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
        grid-auto-columns: minmax(auto, max-content) auto max-content;
        text-wrap: balance;
        -webkit-user-select: none;
                user-select: none;
      }
      :where(li > details > summary) {
        --tw-outline-style: none;
        outline-style: none;
        @media (forced-colors: active) {
          outline: 2px solid transparent;
          outline-offset: 2px;
        }
        &::-webkit-details-marker {
          display: none;
        }
      }
      :where(li > details > summary), :where(li > .menu-dropdown-toggle) {
        &:after {
          justify-self: flex-end;
          display: block;
          height: 0.375rem;
          width: 0.375rem;
          rotate: -135deg;
          translate: 0 -1px;
          transition-property: rotate, translate;
          transition-duration: 0.2s;
          content: "";
          transform-origin: 50% 50%;
          box-shadow: 2px 2px inset;
          pointer-events: none;
        }
      }
      details {
        overflow: hidden;
        interpolate-size: allow-keywords;
      }
      details::details-content {
        block-size: 0;
        @media (prefers-reduced-motion: no-preference) {
          transition-behavior: allow-discrete;
          transition-property: block-size, content-visibility;
          transition-duration: 0.2s;
          transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
        }
      }
      details[open]::details-content {
        block-size: auto;
      }
      :where(li > details[open] > summary):after, :where(li > .menu-dropdown-toggle.menu-dropdown-show):after {
        rotate: 45deg;
        translate: 0 1px;
      }
      :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title), li:not(.menu-title, .disabled) > details > summary:not(.menu-title) ):not(.menu-active, :active, .btn) {
        &.menu-focus, &:focus-visible {
          cursor: pointer;
          background-color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
          }
          color: var(--color-base-content);
          --tw-outline-style: none;
          outline-style: none;
          @media (forced-colors: active) {
            outline: 2px solid transparent;
            outline-offset: 2px;
          }
        }
      }
      :where( li:not(.menu-title, .disabled) > *:not(ul, details, .menu-title):not(.menu-active, :active, .btn):hover, li:not(.menu-title, .disabled) > details > summary:not(.menu-title):not(.menu-active, :active, .btn):hover ) {
        cursor: pointer;
        background-color: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
        }
        --tw-outline-style: none;
        outline-style: none;
        @media (forced-colors: active) {
          outline: 2px solid transparent;
          outline-offset: 2px;
        }
        box-shadow: 0 1px oklch(0% 0 0 / 0.01) inset, 0 -1px oklch(100% 0 0 / 0.01) inset;
      }
      :where(li:empty) {
        background-color: var(--color-base-content);
        opacity: 10%;
        margin: 0.5rem 1rem;
        height: 1px;
      }
      :where(li) {
        position: relative;
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: stretch;
        .badge {
          justify-self: flex-end;
        }
        & > *:not(ul, .menu-title, details, .btn):active, & > *:not(ul, .menu-title, details, .btn).menu-active, & > details > summary:active {
          --tw-outline-style: none;
          outline-style: none;
          @media (forced-colors: active) {
            outline: 2px solid transparent;
            outline-offset: 2px;
          }
          color: var(--menu-active-fg);
          background-color: var(--menu-active-bg);
          background-size: auto, calc(var(--noise) * 100%);
          background-image: none, var(--fx-noise);
          &:not(&:active) {
            box-shadow: 0 2px calc(var(--depth) * 3px) -2px var(--menu-active-bg);
          }
        }
        &.menu-disabled {
          pointer-events: none;
          color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
          }
        }
      }
      .dropdown:focus-within {
        .menu-dropdown-toggle:after {
          rotate: 45deg;
          translate: 0 1px;
        }
      }
      .dropdown-content {
        margin-top: calc(0.25rem * 2);
        padding: calc(0.25rem * 2);
        &:before {
          display: none;
        }
      }
    }
  }
  .dropdown {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      display: inline-block;
      position-area: var(--anchor-v, bottom) var(--anchor-h, span-right);
      & > *:not(:has(~ [class*="dropdown-content"])):focus {
        --tw-outline-style: none;
        outline-style: none;
        @media (forced-colors: active) {
          outline: 2px solid transparent;
          outline-offset: 2px;
        }
      }
      .dropdown-content {
        position: absolute;
      }
      &.dropdown-close .dropdown-content, &:not(details, .dropdown-open, .dropdown-hover:hover, :focus-within) .dropdown-content, &.dropdown-hover:not(:hover) [tabindex]:first-child:focus:not(:focus-visible) ~ .dropdown-content {
        display: none;
        transform-origin: top;
        opacity: 0%;
        scale: 95%;
      }
      &[popover], .dropdown-content {
        z-index: 999;
        @media (prefers-reduced-motion: no-preference) {
          animation: dropdown 0.2s;
          transition-property: opacity, scale, display;
          transition-behavior: allow-discrete;
          transition-duration: 0.2s;
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        }
      }
      @starting-style {
        &[popover], .dropdown-content {
          scale: 95%;
          opacity: 0;
        }
      }
      &:not(.dropdown-close) {
        &.dropdown-open, &:not(.dropdown-hover):focus, &:focus-within {
          > [tabindex]:first-child {
            pointer-events: none;
          }
          .dropdown-content {
            opacity: 100%;
            scale: 100%;
          }
        }
        &.dropdown-hover:hover {
          .dropdown-content {
            opacity: 100%;
            scale: 100%;
          }
        }
      }
      &:is(details) {
        summary {
          &::-webkit-details-marker {
            display: none;
          }
        }
      }
      &:where([popover]) {
        background: #0000;
      }
      &[popover] {
        position: fixed;
        color: inherit;
        @supports not (position-area: bottom) {
          margin: auto;
          &.dropdown-close, &.dropdown-open:not(:popover-open) {
            display: none;
            transform-origin: top;
            opacity: 0%;
            scale: 95%;
          }
          &::backdrop {
            background-color: color-mix(in oklab, #000 30%, #0000);
          }
        }
        &.dropdown-close, &:not(.dropdown-open, :popover-open) {
          display: none;
          transform-origin: top;
          opacity: 0%;
          scale: 95%;
        }
      }
    }
  }
  .btn {
    :where(&) {
      @layer daisyui.l1.l2.l3 {
        width: unset;
      }
    }
    .prose :where(a&:not(.btn-link)):not(:where([class~="not-prose"], [class~="not-prose"] *)) {
      text-decoration-line: none;
    }
    @layer daisyui.l1.l2.l3 {
      display: inline-flex;
      flex-shrink: 0;
      cursor: pointer;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      gap: calc(0.25rem * 1.5);
      text-align: center;
      vertical-align: middle;
      outline-offset: 2px;
      webkit-user-select: none;
      -webkit-user-select: none;
              user-select: none;
      padding-inline: var(--btn-p);
      color: var(--btn-fg);
      --tw-prose-links: var(--btn-fg);
      height: var(--size);
      font-size: var(--fontsize, 0.875rem);
      font-weight: 600;
      outline-color: var(--btn-color, var(--color-base-content));
      transition-property: color, background-color, border-color, box-shadow;
      transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
      transition-duration: 0.2s;
      border-start-start-radius: var(--join-ss, var(--radius-field));
      border-start-end-radius: var(--join-se, var(--radius-field));
      border-end-start-radius: var(--join-es, var(--radius-field));
      border-end-end-radius: var(--join-ee, var(--radius-field));
      background-color: var(--btn-bg);
      background-size: auto, calc(var(--noise) * 100%);
      background-image: none, var(--btn-noise);
      border-width: var(--border);
      border-style: solid;
      border-color: var(--btn-border);
      text-shadow: 0 0.5px oklch(100% 0 0 / calc(var(--depth) * 0.15));
      touch-action: manipulation;
      box-shadow: 0 0.5px 0 0.5px oklch(100% 0 0 / calc(var(--depth) * 6%)) inset, var(--btn-shadow);
      --size: calc(var(--size-field, 0.25rem) * 10);
      --btn-bg: var(--btn-color, var(--color-base-200));
      --btn-fg: var(--color-base-content);
      --btn-p: 1rem;
      --btn-border: var(--btn-bg);
      @supports (color: color-mix(in lab, red, red)) {
        --btn-border: color-mix(in oklab, var(--btn-bg), #000 calc(var(--depth) * 5%));
      }
      --btn-shadow: 0 3px 2px -2px var(--btn-bg),
      0 4px 3px -2px var(--btn-bg);
      @supports (color: color-mix(in lab, red, red)) {
        --btn-shadow: 0 3px 2px -2px color-mix(in oklab, var(--btn-bg) calc(var(--depth) * 30%), #0000),
      0 4px 3px -2px color-mix(in oklab, var(--btn-bg) calc(var(--depth) * 30%), #0000);
      }
      --btn-noise: var(--fx-noise);
      @media (hover: hover) {
        &:hover {
          --btn-bg: var(--btn-color, var(--color-base-200));
          @supports (color: color-mix(in lab, red, red)) {
            --btn-bg: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 7%);
          }
        }
      }
      &:focus-visible, &:has(:focus-visible) {
        outline-width: 2px;
        outline-style: solid;
        isolation: isolate;
      }
      &:active:not(.btn-active) {
        translate: 0 0.5px;
        --btn-bg: var(--btn-color, var(--color-base-200));
        @supports (color: color-mix(in lab, red, red)) {
          --btn-bg: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 5%);
        }
        --btn-border: var(--btn-color, var(--color-base-200));
        @supports (color: color-mix(in lab, red, red)) {
          --btn-border: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 7%);
        }
        --btn-shadow: 0 0 0 0 oklch(0% 0 0/0), 0 0 0 0 oklch(0% 0 0/0);
      }
      &:is(input[type="checkbox"], input[type="radio"]) {
        appearance: none;
        &[aria-label]::after {
          --tw-content: attr(aria-label);
          content: var(--tw-content);
        }
      }
      &:where(input:checked:not(.filter .btn)) {
        --btn-color: var(--color-primary);
        --btn-fg: var(--color-primary-content);
        isolation: isolate;
      }
    }
    &:disabled {
      @layer daisyui.l1.l2 {
        &:not(.btn-link, .btn-ghost) {
          background-color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
          }
          box-shadow: none;
        }
        pointer-events: none;
        --btn-border: #0000;
        --btn-noise: none;
        --btn-fg: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          --btn-fg: color-mix(in oklch, var(--color-base-content) 20%, #0000);
        }
      }
    }
    &[disabled] {
      @layer daisyui.l1.l2 {
        &:not(.btn-link, .btn-ghost) {
          background-color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
          }
          box-shadow: none;
        }
        pointer-events: none;
        --btn-border: #0000;
        --btn-noise: none;
        --btn-fg: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          --btn-fg: color-mix(in oklch, var(--color-base-content) 20%, #0000);
        }
      }
    }
  }
  .loading {
    @layer daisyui.l1.l2.l3 {
      pointer-events: none;
      display: inline-block;
      aspect-ratio: 1 / 1;
      background-color: currentcolor;
      vertical-align: middle;
      width: calc(var(--size-selector, 0.25rem) * 6);
      mask-size: 100%;
      mask-repeat: no-repeat;
      mask-position: center;
      mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }
  }
  .pointer-events-auto {
    pointer-events: auto;
  }
  .visible {
    visibility: visible;
  }
  .toast {
    @layer daisyui.l1.l2.l3 {
      position: fixed;
      inset-inline-start: auto;
      inset-inline-end: calc(0.25rem * 4);
      top: auto;
      bottom: calc(0.25rem * 4);
      display: flex;
      flex-direction: column;
      gap: calc(0.25rem * 2);
      background-color: transparent;
      translate: var(--toast-x, 0) var(--toast-y, 0);
      width: max-content;
      max-width: calc(100vw - 2rem);
      & > * {
        @media (prefers-reduced-motion: no-preference) {
          animation: toast 0.25s ease-out;
        }
      }
    }
  }
  .toggle {
    @layer daisyui.l1.l2.l3 {
      border: var(--border) solid currentColor;
      color: var(--input-color);
      position: relative;
      display: inline-grid;
      flex-shrink: 0;
      cursor: pointer;
      appearance: none;
      place-content: center;
      vertical-align: middle;
      webkit-user-select: none;
      -webkit-user-select: none;
              user-select: none;
      grid-template-columns: 0fr 1fr 1fr;
      --radius-selector-max: calc(
      var(--radius-selector) + var(--radius-selector) + var(--radius-selector)
    );
      border-radius: calc( var(--radius-selector) + min(var(--toggle-p), var(--radius-selector-max)) + min(var(--border), var(--radius-selector-max)) );
      padding: var(--toggle-p);
      box-shadow: 0 1px currentColor inset;
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 1px color-mix(in oklab, currentColor calc(var(--depth) * 10%), #0000) inset;
      }
      transition: color 0.3s, grid-template-columns 0.2s;
      --input-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        --input-color: color-mix(in oklab, var(--color-base-content) 50%, #0000);
      }
      --toggle-p: calc(var(--size) * 0.125);
      --size: calc(var(--size-selector, 0.25rem) * 6);
      width: calc((var(--size) * 2) - (var(--border) + var(--toggle-p)) * 2);
      height: var(--size);
      > * {
        z-index: 1;
        grid-column: span 1 / span 1;
        grid-column-start: 2;
        grid-row-start: 1;
        height: 100%;
        cursor: pointer;
        appearance: none;
        background-color: transparent;
        padding: calc(0.25rem * 0.5);
        transition: opacity 0.2s, rotate 0.4s;
        border: none;
        &:focus {
          --tw-outline-style: none;
          outline-style: none;
          @media (forced-colors: active) {
            outline: 2px solid transparent;
            outline-offset: 2px;
          }
        }
        &:nth-child(2) {
          color: var(--color-base-100);
          rotate: 0deg;
        }
        &:nth-child(3) {
          color: var(--color-base-100);
          opacity: 0%;
          rotate: -15deg;
        }
      }
      &:has(:checked) {
        > :nth-child(2) {
          opacity: 0%;
          rotate: 15deg;
        }
        > :nth-child(3) {
          opacity: 100%;
          rotate: 0deg;
        }
      }
      &:before {
        position: relative;
        inset-inline-start: calc(0.25rem * 0);
        grid-column-start: 2;
        grid-row-start: 1;
        aspect-ratio: 1 / 1;
        height: 100%;
        width: 100%;
        border-radius: var(--radius-selector);
        background-color: currentcolor;
        translate: 0;
        --tw-content: "";
        content: var(--tw-content);
        transition: background-color 0.1s, translate 0.2s, inset-inline-start 0.2s;
        box-shadow: 0 -1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px currentColor;
        @supports (color: color-mix(in lab, red, red)) {
          box-shadow: 0 -1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px color-mix(in oklab, currentColor calc(var(--depth) * 10%), #0000);
        }
        background-size: auto, calc(var(--noise) * 100%);
        background-image: none, var(--fx-noise);
      }
      @media (forced-colors: active) {
        &:before {
          outline-style: var(--tw-outline-style);
          outline-width: 1px;
          outline-offset: calc(1px * -1);
        }
      }
      @media print {
        &:before {
          outline: 0.25rem solid;
          outline-offset: -1rem;
        }
      }
      &:focus-visible, &:has(:focus-visible) {
        outline: 2px solid currentColor;
        outline-offset: 2px;
      }
      &:checked, &[aria-checked="true"], &:has(> input:checked) {
        grid-template-columns: 1fr 1fr 0fr;
        background-color: var(--color-base-100);
        --input-color: var(--color-base-content);
        &:before {
          background-color: currentcolor;
        }
        @starting-style {
          &:before {
            opacity: 0;
          }
        }
      }
      &:indeterminate {
        grid-template-columns: 0.5fr 1fr 0.5fr;
      }
      &:disabled {
        cursor: not-allowed;
        opacity: 30%;
        &:before {
          background-color: transparent;
          border: var(--border) solid currentColor;
        }
      }
    }
  }
  .input {
    @layer daisyui.l1.l2.l3 {
      cursor: text;
      border: var(--border) solid #0000;
      position: relative;
      display: inline-flex;
      flex-shrink: 1;
      appearance: none;
      align-items: center;
      gap: calc(0.25rem * 2);
      background-color: var(--color-base-100);
      padding-inline: calc(0.25rem * 3);
      vertical-align: middle;
      white-space: nowrap;
      width: clamp(3rem, 20rem, 100%);
      height: var(--size);
      font-size: max(var(--font-size, 0.875rem), 0.875rem);
      touch-action: manipulation;
      border-start-start-radius: var(--join-ss, var(--radius-field));
      border-start-end-radius: var(--join-se, var(--radius-field));
      border-end-start-radius: var(--join-es, var(--radius-field));
      border-end-end-radius: var(--join-ee, var(--radius-field));
      border-color: var(--input-color);
      box-shadow: 0 1px var(--input-color) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      }
      --size: calc(var(--size-field, 0.25rem) * 10);
      --input-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
      }
      &:where(input) {
        display: inline-flex;
      }
      :where(input) {
        display: inline-flex;
        height: 100%;
        width: 100%;
        appearance: none;
        background-color: transparent;
        border: none;
        &:focus, &:focus-within {
          --tw-outline-style: none;
          outline-style: none;
          @media (forced-colors: active) {
            outline: 2px solid transparent;
            outline-offset: 2px;
          }
        }
      }
      :where(input[type="url"]), :where(input[type="email"]) {
        direction: ltr;
      }
      :where(input[type="date"]) {
        display: inline-flex;
      }
      &:focus, &:focus-within {
        --input-color: var(--color-base-content);
        box-shadow: 0 1px var(--input-color);
        @supports (color: color-mix(in lab, red, red)) {
          box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000);
        }
        outline: 2px solid var(--input-color);
        outline-offset: 2px;
        isolation: isolate;
      }
      @media (pointer: coarse) {
        @supports (-webkit-touch-callout: none) {
          &:focus, &:focus-within {
            --font-size: 1rem;
          }
        }
      }
      &:has(> input[disabled]), &:is(:disabled, [disabled]), fieldset:disabled & {
        cursor: not-allowed;
        border-color: var(--color-base-200);
        background-color: var(--color-base-200);
        color: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
        }
        &::placeholder {
          color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
          }
        }
        box-shadow: none;
      }
      &:has(> input[disabled]) > input[disabled] {
        cursor: not-allowed;
      }
      &::-webkit-date-and-time-value {
        text-align: inherit;
      }
      &[type="number"] {
        &::-webkit-inner-spin-button {
          margin-block: calc(0.25rem * -3);
          margin-inline-end: calc(0.25rem * -3);
        }
      }
      &::-webkit-calendar-picker-indicator {
        position: absolute;
        inset-inline-end: 0.75em;
      }
      &:has(> input[type="date"]) {
        :where(input[type="date"]) {
          display: inline-flex;
          webkit-appearance: none;
          appearance: none;
        }
        input[type="date"]::-webkit-calendar-picker-indicator {
          position: absolute;
          inset-inline-end: 0.75em;
          width: 1em;
          height: 1em;
          cursor: pointer;
        }
      }
    }
  }
  .table {
    @layer daisyui.l1.l2.l3 {
      font-size: 0.875rem;
      position: relative;
      width: 100%;
      border-collapse: separate;
      --tw-border-spacing-x: calc(0.25rem * 0);
      --tw-border-spacing-y: calc(0.25rem * 0);
      border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
      border-radius: var(--radius-box);
      text-align: left;
      &:where(:dir(rtl), [dir="rtl"], [dir="rtl"] *) {
        text-align: right;
      }
      tr.row-hover {
        &, &:nth-child(even) {
          &:hover {
            @media (hover: hover) {
              background-color: var(--color-base-200);
            }
          }
        }
      }
      :where(th, td) {
        padding-inline: calc(0.25rem * 4);
        padding-block: calc(0.25rem * 3);
        vertical-align: middle;
      }
      :where(thead, tfoot) {
        white-space: nowrap;
        color: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklab, var(--color-base-content) 60%, transparent);
        }
        font-size: 0.875rem;
        font-weight: 600;
      }
      :where(tfoot tr:first-child :is(td, th)) {
        border-top: var(--border) solid var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          border-top: var(--border) solid color-mix(in oklch, var(--color-base-content) 5%, #0000);
        }
      }
      :where(.table-pin-rows thead tr) {
        position: sticky;
        top: calc(0.25rem * 0);
        z-index: 1;
        background-color: var(--color-base-100);
      }
      :where(.table-pin-rows tfoot tr) {
        position: sticky;
        bottom: calc(0.25rem * 0);
        z-index: 1;
        background-color: var(--color-base-100);
      }
      :where(.table-pin-cols tr th) {
        position: sticky;
        right: calc(0.25rem * 0);
        left: calc(0.25rem * 0);
        background-color: var(--color-base-100);
      }
      :where(thead tr :is(td, th), tbody tr:not(:last-child) :is(td, th)) {
        border-bottom: var(--border) solid var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          border-bottom: var(--border) solid color-mix(in oklch, var(--color-base-content) 5%, #0000);
        }
      }
    }
  }
  .select {
    @layer daisyui.l1.l2.l3 {
      border: var(--border) solid #0000;
      position: relative;
      display: inline-flex;
      flex-shrink: 1;
      appearance: none;
      align-items: center;
      gap: calc(0.25rem * 1.5);
      background-color: var(--color-base-100);
      padding-inline-start: calc(0.25rem * 3);
      padding-inline-end: calc(0.25rem * 7);
      vertical-align: middle;
      width: clamp(3rem, 20rem, 100%);
      height: var(--size);
      font-size: 0.875rem;
      touch-action: manipulation;
      border-start-start-radius: var(--join-ss, var(--radius-field));
      border-start-end-radius: var(--join-se, var(--radius-field));
      border-end-start-radius: var(--join-es, var(--radius-field));
      border-end-end-radius: var(--join-ee, var(--radius-field));
      background-image: linear-gradient(45deg, #0000 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, #0000 50%);
      background-position: calc(100% - 20px) calc(1px + 50%), calc(100% - 16.1px) calc(1px + 50%);
      background-size: 4px 4px, 4px 4px;
      background-repeat: no-repeat;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      box-shadow: 0 1px var(--input-color) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      }
      border-color: var(--input-color);
      --input-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
      }
      --size: calc(var(--size-field, 0.25rem) * 10);
      [dir="rtl"] & {
        background-position: calc(0% + 12px) calc(1px + 50%), calc(0% + 16px) calc(1px + 50%);
        &::picker(select), select::picker(select) {
          translate: 0.5rem 0;
        }
      }
      &[multiple] {
        height: auto;
        overflow: auto;
        padding-block: calc(0.25rem * 3);
        padding-inline-end: calc(0.25rem * 3);
        background-image: none;
      }
      select {
        margin-inline-start: calc(0.25rem * -3);
        margin-inline-end: calc(0.25rem * -7);
        width: calc(100% + 2.75rem);
        appearance: none;
        padding-inline-start: calc(0.25rem * 3);
        padding-inline-end: calc(0.25rem * 7);
        height: calc(100% - calc(var(--border) * 2));
        align-items: center;
        background: inherit;
        border-radius: inherit;
        border-style: none;
        &:focus, &:focus-within {
          --tw-outline-style: none;
          outline-style: none;
          @media (forced-colors: active) {
            outline: 2px solid transparent;
            outline-offset: 2px;
          }
        }
        &:not(:last-child) {
          margin-inline-end: calc(0.25rem * -5.5);
          background-image: none;
        }
      }
      &:focus, &:focus-within {
        --input-color: var(--color-base-content);
        box-shadow: 0 1px var(--input-color);
        @supports (color: color-mix(in lab, red, red)) {
          box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000);
        }
        outline: 2px solid var(--input-color);
        outline-offset: 2px;
        isolation: isolate;
      }
      &:has(> select[disabled]), &:is(:disabled, [disabled]), fieldset:disabled & {
        cursor: not-allowed;
        border-color: var(--color-base-200);
        background-color: var(--color-base-200);
        color: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
        }
        &::placeholder {
          color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
          }
        }
      }
      &:has(> select[disabled]) > select[disabled] {
        cursor: not-allowed;
      }
      &, & select {
        @supports (appearance: base-select) {
          appearance: base-select;
        }
        @supports (appearance: base-select) {
          &::picker(select) {
            appearance: base-select;
          }
        }
        &::picker(select) {
          color: inherit;
          max-height: min(24rem, 70dvh);
          margin-inline: 0.5rem;
          translate: -0.5rem 0;
          border: var(--border) solid var(--color-base-200);
          margin-block: calc(0.25rem * 2);
          border-radius: var(--radius-box);
          padding: calc(0.25rem * 2);
          background-color: inherit;
          box-shadow: 0 2px calc(var(--depth) * 3px) -2px oklch(0% 0 0/0.2);
          box-shadow: 0 20px 25px -5px rgb(0 0 0 / calc(var(--depth) * 0.1)), 0 8px 10px -6px rgb(0 0 0 / calc(var(--depth) * 0.1));
        }
        &::picker-icon {
          display: none;
        }
        optgroup {
          padding-top: 0.5em;
          option {
            &:nth-child(1) {
              margin-top: 0.5em;
            }
          }
        }
        option {
          border-radius: var(--radius-field);
          padding-inline: calc(0.25rem * 3);
          padding-block: calc(0.25rem * 1.5);
          transition-property: color, background-color;
          transition-duration: 0.2s;
          transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
          white-space: normal;
          &:not(:disabled) {
            &:hover, &:focus-visible {
              cursor: pointer;
              background-color: var(--color-base-content);
              @supports (color: color-mix(in lab, red, red)) {
                background-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
              }
              --tw-outline-style: none;
              outline-style: none;
              @media (forced-colors: active) {
                outline: 2px solid transparent;
                outline-offset: 2px;
              }
            }
            &:active {
              background-color: var(--color-neutral);
              color: var(--color-neutral-content);
              box-shadow: 0 2px calc(var(--depth) * 3px) -2px var(--color-neutral);
            }
          }
        }
      }
    }
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .checkbox {
    @layer daisyui.l1.l2.l3 {
      border: var(--border) solid var(--input-color, var(--color-base-content));
      @supports (color: color-mix(in lab, red, red)) {
        border: var(--border) solid var(--input-color, color-mix(in oklab, var(--color-base-content) 20%, #0000));
      }
      position: relative;
      display: inline-block;
      flex-shrink: 0;
      cursor: pointer;
      appearance: none;
      border-radius: var(--radius-selector);
      padding: calc(0.25rem * 1);
      vertical-align: middle;
      color: var(--color-base-content);
      box-shadow: 0 1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 0 #0000 inset, 0 0 #0000;
      transition: background-color 0.2s, box-shadow 0.2s;
      --size: calc(var(--size-selector, 0.25rem) * 6);
      width: var(--size);
      height: var(--size);
      background-size: auto, calc(var(--noise) * 100%);
      background-image: none, var(--fx-noise);
      &:before {
        --tw-content: "";
        content: var(--tw-content);
        display: block;
        width: 100%;
        height: 100%;
        rotate: 45deg;
        background-color: currentcolor;
        opacity: 0%;
        transition: clip-path 0.3s, opacity 0.1s, rotate 0.3s, translate 0.3s;
        transition-delay: 0.1s;
        clip-path: polygon(20% 100%, 20% 80%, 50% 80%, 50% 80%, 70% 80%, 70% 100%);
        box-shadow: 0px 3px 0 0px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
        font-size: 1rem;
        line-height: 0.75;
      }
      &:focus-visible {
        outline: 2px solid var(--input-color, currentColor);
        outline-offset: 2px;
      }
      &:checked, &[aria-checked="true"] {
        background-color: var(--input-color, #0000);
        box-shadow: 0 0 #0000 inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px oklch(0% 0 0 / calc(var(--depth) * 0.1));
        &:before {
          clip-path: polygon(20% 100%, 20% 80%, 50% 80%, 50% 0%, 70% 0%, 70% 100%);
          opacity: 100%;
        }
        @media (forced-colors: active) {
          &:before {
            rotate: 0deg;
            background-color: transparent;
            --tw-content: "✔︎";
            clip-path: none;
          }
        }
        @media print {
          &:before {
            rotate: 0deg;
            background-color: transparent;
            --tw-content: "✔︎";
            clip-path: none;
          }
        }
      }
      &:indeterminate {
        background-color: var( --input-color, var(--color-base-content) );
        @supports (color: color-mix(in lab, red, red)) {
          background-color: var( --input-color, color-mix(in oklab, var(--color-base-content) 20%, #0000) );
        }
        &:before {
          rotate: 0deg;
          opacity: 100%;
          translate: 0 -35%;
          clip-path: polygon(20% 100%, 20% 80%, 50% 80%, 50% 80%, 80% 80%, 80% 100%);
        }
      }
    }
    &:disabled {
      @layer daisyui.l1.l2 {
        cursor: not-allowed;
        opacity: 20%;
      }
    }
  }
  .radio {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      display: inline-block;
      flex-shrink: 0;
      cursor: pointer;
      appearance: none;
      border-radius: calc(infinity * 1px);
      padding: calc(0.25rem * 1);
      vertical-align: middle;
      border: var(--border) solid var(--input-color, currentColor);
      @supports (color: color-mix(in lab, red, red)) {
        border: var(--border) solid var(--input-color, color-mix(in srgb, currentColor 20%, #0000));
      }
      box-shadow: 0 1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset;
      --size: calc(var(--size-selector, 0.25rem) * 6);
      width: var(--size);
      height: var(--size);
      color: var(--input-color, currentColor);
      &:before {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: calc(infinity * 1px);
        --tw-content: "";
        content: var(--tw-content);
        background-size: auto, calc(var(--noise) * 100%);
        background-image: none, var(--fx-noise);
      }
      &:focus-visible {
        outline: 2px solid currentColor;
      }
      &:checked, &[aria-checked="true"] {
        border-color: currentcolor;
        background-color: var(--color-base-100);
        @media (prefers-reduced-motion: no-preference) {
          animation: radio 0.2s ease-out;
        }
        &:before {
          background-color: currentcolor;
          box-shadow: 0 -1px oklch(0% 0 0 / calc(var(--depth) * 0.1)) inset, 0 8px 0 -4px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset, 0 1px oklch(0% 0 0 / calc(var(--depth) * 0.1));
        }
        @media (forced-colors: active) {
          &:before {
            outline-style: var(--tw-outline-style);
            outline-width: 1px;
            outline-offset: calc(1px * -1);
          }
        }
        @media print {
          &:before {
            outline: 0.25rem solid;
            outline-offset: -1rem;
          }
        }
      }
    }
    &:disabled {
      @layer daisyui.l1.l2 {
        cursor: not-allowed;
        opacity: 20%;
      }
    }
  }
  .card {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      display: flex;
      flex-direction: column;
      border-radius: var(--radius-box);
      outline-width: 2px;
      transition: outline 0.2s ease-in-out;
      outline: 0 solid #0000;
      outline-offset: 2px;
      &:focus {
        --tw-outline-style: none;
        outline-style: none;
        @media (forced-colors: active) {
          outline: 2px solid transparent;
          outline-offset: 2px;
        }
      }
      &:focus-visible {
        outline-color: currentColor;
      }
      :where(figure:first-child) {
        overflow: hidden;
        border-start-start-radius: inherit;
        border-start-end-radius: inherit;
        border-end-start-radius: unset;
        border-end-end-radius: unset;
      }
      :where(figure:last-child) {
        overflow: hidden;
        border-start-start-radius: unset;
        border-start-end-radius: unset;
        border-end-start-radius: inherit;
        border-end-end-radius: inherit;
      }
      figure {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:has(> input:is(input[type="checkbox"], input[type="radio"])) {
        cursor: pointer;
        -webkit-user-select: none;
                user-select: none;
      }
      &:has(> :checked) {
        outline: 2px solid currentColor;
      }
    }
  }
  .stats {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      display: inline-grid;
      grid-auto-flow: column;
      overflow-x: auto;
      border-radius: var(--radius-box);
    }
  }
  .progress {
    @layer daisyui.l1.l2.l3 {
      position: relative;
      height: calc(0.25rem * 2);
      width: 100%;
      appearance: none;
      overflow: hidden;
      border-radius: var(--radius-box);
      background-color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, currentcolor 20%, transparent);
      }
      color: var(--color-base-content);
      &:indeterminate {
        background-image: repeating-linear-gradient( 90deg, currentColor -1%, currentColor 10%, #0000 10%, #0000 90% );
        background-size: 200%;
        background-position-x: 15%;
        @media (prefers-reduced-motion: no-preference) {
          animation: progress 5s ease-in-out infinite;
        }
        @supports (-moz-appearance: none) {
          &::-moz-progress-bar {
            background-color: transparent;
            @media (prefers-reduced-motion: no-preference) {
              animation: progress 5s ease-in-out infinite;
              background-image: repeating-linear-gradient( 90deg, currentColor -1%, currentColor 10%, #0000 10%, #0000 90% );
              background-size: 200%;
              background-position-x: 15%;
            }
          }
        }
      }
      @supports (-moz-appearance: none) {
        &::-moz-progress-bar {
          border-radius: var(--radius-box);
          background-color: currentcolor;
        }
      }
      @supports (-webkit-appearance: none) {
        &::-webkit-progress-bar {
          border-radius: var(--radius-box);
          background-color: transparent;
        }
        &::-webkit-progress-value {
          border-radius: var(--radius-box);
          background-color: currentColor;
        }
      }
    }
  }
  .absolute {
    position: absolute;
  }
  .sticky {
    position: sticky;
  }
  .start {
    inset-inline-start: var(--spacing);
  }
  .dropdown-end {
    @layer daisyui.l1.l2 {
      --anchor-h: span-left;
      :where(.dropdown-content) {
        inset-inline-end: calc(0.25rem * 0);
        translate: 0 0;
        [dir="rtl"] & {
          translate: 0 0;
        }
      }
      &.dropdown-left {
        --anchor-h: left;
        --anchor-v: span-top;
        .dropdown-content {
          top: auto;
          bottom: calc(0.25rem * 0);
        }
      }
      &.dropdown-right {
        --anchor-h: right;
        --anchor-v: span-top;
        .dropdown-content {
          top: auto;
          bottom: calc(0.25rem * 0);
        }
      }
    }
  }
  .end {
    inset-inline-end: var(--spacing);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-2 {
    top: calc(var(--spacing) * 2);
  }
  .right-2 {
    right: calc(var(--spacing) * 2);
  }
  .join {
    display: inline-flex;
    align-items: stretch;
    --join-ss: 0;
    --join-se: 0;
    --join-es: 0;
    --join-ee: 0;
    :where(.join-item) {
      border-start-start-radius: var(--join-ss, 0);
      border-start-end-radius: var(--join-se, 0);
      border-end-start-radius: var(--join-es, 0);
      border-end-end-radius: var(--join-ee, 0);
      * {
        --join-ss: var(--radius-field);
        --join-se: var(--radius-field);
        --join-es: var(--radius-field);
        --join-ee: var(--radius-field);
      }
    }
    > .join-item:where(:first-child) {
      --join-ss: var(--radius-field);
      --join-se: 0;
      --join-es: var(--radius-field);
      --join-ee: 0;
    }
    :first-child:not(:last-child) {
      :where(.join-item) {
        --join-ss: var(--radius-field);
        --join-se: 0;
        --join-es: var(--radius-field);
        --join-ee: 0;
      }
    }
    > .join-item:where(:last-child) {
      --join-ss: 0;
      --join-se: var(--radius-field);
      --join-es: 0;
      --join-ee: var(--radius-field);
    }
    :last-child:not(:first-child) {
      :where(.join-item) {
        --join-ss: 0;
        --join-se: var(--radius-field);
        --join-es: 0;
        --join-ee: var(--radius-field);
      }
    }
    > .join-item:where(:only-child) {
      --join-ss: var(--radius-field);
      --join-se: var(--radius-field);
      --join-es: var(--radius-field);
      --join-ee: var(--radius-field);
    }
    :only-child {
      :where(.join-item) {
        --join-ss: var(--radius-field);
        --join-se: var(--radius-field);
        --join-es: var(--radius-field);
        --join-ee: var(--radius-field);
      }
    }
    > :where(:focus, :has(:focus)) {
      z-index: 1;
    }
    @media (hover: hover) {
      > :where(.btn:hover, :has(.btn:hover)) {
        isolation: isolate;
      }
    }
  }
  .file-input {
    @layer daisyui.l1.l2.l3 {
      cursor: pointer;
      cursor: pointer;
      border: var(--border) solid #0000;
      display: inline-flex;
      appearance: none;
      align-items: center;
      background-color: var(--color-base-100);
      vertical-align: middle;
      webkit-user-select: none;
      -webkit-user-select: none;
              user-select: none;
      width: clamp(3rem, 20rem, 100%);
      height: var(--size);
      padding-inline-end: 0.75rem;
      font-size: 0.875rem;
      line-height: 2;
      border-start-start-radius: var(--join-ss, var(--radius-field));
      border-start-end-radius: var(--join-se, var(--radius-field));
      border-end-start-radius: var(--join-es, var(--radius-field));
      border-end-end-radius: var(--join-ee, var(--radius-field));
      border-color: var(--input-color);
      box-shadow: 0 1px var(--input-color) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      }
      --size: calc(var(--size-field, 0.25rem) * 10);
      --input-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
      }
      &::file-selector-button {
        margin-inline-end: calc(0.25rem * 4);
        cursor: pointer;
        padding-inline: calc(0.25rem * 4);
        webkit-user-select: none;
        -webkit-user-select: none;
                user-select: none;
        height: calc(100% + var(--border) * 2);
        margin-block: calc(var(--border) * -1);
        margin-inline-start: calc(var(--border) * -1);
        font-size: 0.875rem;
        color: var(--btn-fg);
        border-width: var(--border);
        border-style: solid;
        border-color: var(--btn-border);
        border-start-start-radius: calc(var(--join-ss, var(--radius-field) - var(--border)));
        border-end-start-radius: calc(var(--join-es, var(--radius-field) - var(--border)));
        font-weight: 600;
        background-color: var(--btn-bg);
        background-size: calc(var(--noise) * 100%);
        background-image: var(--btn-noise);
        text-shadow: 0 0.5px oklch(1 0 0 / calc(var(--depth) * 0.15));
        box-shadow: 0 0.5px 0 0.5px white inset, var(--btn-shadow);
        @supports (color: color-mix(in lab, red, red)) {
          box-shadow: 0 0.5px 0 0.5px color-mix( in oklab, color-mix(in oklab, white 30%, var(--btn-bg)) calc(var(--depth) * 20%), #0000 ) inset, var(--btn-shadow);
        }
        --size: calc(var(--size-field, 0.25rem) * 10);
        --btn-bg: var(--btn-color, var(--color-base-200));
        --btn-fg: var(--color-base-content);
        --btn-border: var(--btn-bg);
        @supports (color: color-mix(in lab, red, red)) {
          --btn-border: color-mix(in oklab, var(--btn-bg), #000 5%);
        }
        --btn-shadow: 0 3px 2px -2px var(--btn-bg),
        0 4px 3px -2px var(--btn-bg);
        @supports (color: color-mix(in lab, red, red)) {
          --btn-shadow: 0 3px 2px -2px color-mix(in oklab, var(--btn-bg) 30%, #0000),
        0 4px 3px -2px color-mix(in oklab, var(--btn-bg) 30%, #0000);
        }
        --btn-noise: var(--fx-noise);
      }
      &:focus {
        --input-color: var(--color-base-content);
        box-shadow: 0 1px var(--input-color);
        @supports (color: color-mix(in lab, red, red)) {
          box-shadow: 0 1px color-mix(in oklab, var(--input-color) 10%, #0000);
        }
        outline: 2px solid var(--input-color);
        outline-offset: 2px;
        isolation: isolate;
      }
      &:has(> input[disabled]), &:is(:disabled, [disabled]) {
        cursor: not-allowed;
        border-color: var(--color-base-200);
        background-color: var(--color-base-200);
        &::placeholder {
          color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
          }
        }
        box-shadow: none;
        color: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklch, var(--color-base-content) 20%, #0000);
        }
        &::file-selector-button {
          cursor: not-allowed;
          border-color: var(--color-base-200);
          background-color: var(--color-base-200);
          --btn-border: #0000;
          --btn-noise: none;
          --btn-fg: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            --btn-fg: color-mix(in oklch, var(--color-base-content) 20%, #0000);
          }
        }
      }
    }
  }
  .textarea {
    @layer daisyui.l1.l2.l3 {
      border: var(--border) solid #0000;
      min-height: calc(0.25rem * 20);
      flex-shrink: 1;
      appearance: none;
      border-radius: var(--radius-field);
      background-color: var(--color-base-100);
      padding-block: calc(0.25rem * 2);
      vertical-align: middle;
      width: clamp(3rem, 20rem, 100%);
      padding-inline-start: 0.75rem;
      padding-inline-end: 0.75rem;
      font-size: max(var(--font-size, 0.875rem), 0.875rem);
      touch-action: manipulation;
      border-color: var(--input-color);
      box-shadow: 0 1px var(--input-color) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000) inset, 0 -1px oklch(100% 0 0 / calc(var(--depth) * 0.1)) inset;
      }
      --input-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        --input-color: color-mix(in oklab, var(--color-base-content) 20%, #0000);
      }
      textarea {
        appearance: none;
        background-color: transparent;
        border: none;
        &:focus, &:focus-within {
          --tw-outline-style: none;
          outline-style: none;
          @media (forced-colors: active) {
            outline: 2px solid transparent;
            outline-offset: 2px;
          }
        }
      }
      &:focus, &:focus-within {
        --input-color: var(--color-base-content);
        box-shadow: 0 1px var(--input-color);
        @supports (color: color-mix(in lab, red, red)) {
          box-shadow: 0 1px color-mix(in oklab, var(--input-color) calc(var(--depth) * 10%), #0000);
        }
        outline: 2px solid var(--input-color);
        outline-offset: 2px;
        isolation: isolate;
      }
      @media (pointer: coarse) {
        @supports (-webkit-touch-callout: none) {
          &:focus, &:focus-within {
            --font-size: 1rem;
          }
        }
      }
      &:has(> textarea[disabled]), &:is(:disabled, [disabled]) {
        cursor: not-allowed;
        border-color: var(--color-base-200);
        background-color: var(--color-base-200);
        color: var(--color-base-content);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
        }
        &::placeholder {
          color: var(--color-base-content);
          @supports (color: color-mix(in lab, red, red)) {
            color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
          }
        }
        box-shadow: none;
      }
      &:has(> textarea[disabled]) > textarea[disabled] {
        cursor: not-allowed;
      }
    }
  }
  .btn-active {
    @layer daisyui.l1.l2 {
      --btn-bg: var(--btn-color, var(--color-base-200));
      @supports (color: color-mix(in lab, red, red)) {
        --btn-bg: color-mix(in oklab, var(--btn-color, var(--color-base-200)), #000 7%);
      }
      --btn-shadow: 0 0 0 0 oklch(0% 0 0/0), 0 0 0 0 oklch(0% 0 0/0);
      isolation: isolate;
    }
  }
  .stack {
    @layer daisyui.l1.l2.l3 {
      display: inline-grid;
      grid-template-columns: 3px 4px 1fr 4px 3px;
      grid-template-rows: 3px 4px 1fr 4px 3px;
      & > * {
        height: 100%;
        width: 100%;
        &:nth-child(n + 2) {
          width: 100%;
          opacity: 70%;
        }
        &:nth-child(2) {
          z-index: 2;
          opacity: 90%;
        }
        &:nth-child(1) {
          z-index: 3;
          width: 100%;
        }
      }
    }
    @layer daisyui.l1.l2 {
      &, &.stack-bottom {
        > * {
          grid-column: 3 / 4;
          grid-row: 3 / 6;
          &:nth-child(2) {
            grid-column: 2 / 5;
            grid-row: 2 / 5;
          }
          &:nth-child(1) {
            grid-column: 1 / 6;
            grid-row: 1 / 4;
          }
        }
      }
      &.stack-top {
        > * {
          grid-column: 3 / 4;
          grid-row: 1 / 4;
          &:nth-child(2) {
            grid-column: 2 / 5;
            grid-row: 2 / 5;
          }
          &:nth-child(1) {
            grid-column: 1 / 6;
            grid-row: 3 / 6;
          }
        }
      }
      &.stack-start {
        > * {
          grid-column: 1 / 4;
          grid-row: 3 / 4;
          &:nth-child(2) {
            grid-column: 2 / 5;
            grid-row: 2 / 5;
          }
          &:nth-child(1) {
            grid-column: 3 / 6;
            grid-row: 1 / 6;
          }
        }
      }
      &.stack-end {
        > * {
          grid-column: 3 / 6;
          grid-row: 3 / 4;
          &:nth-child(2) {
            grid-column: 2 / 5;
            grid-row: 2 / 5;
          }
          &:nth-child(1) {
            grid-column: 1 / 4;
            grid-row: 1 / 6;
          }
        }
      }
    }
  }
  .modal-backdrop {
    @layer daisyui.l1.l2.l3 {
      grid-column-start: 1;
      grid-row-start: 1;
      display: grid;
      align-self: stretch;
      justify-self: stretch;
      color: transparent;
      z-index: -1;
      button {
        cursor: pointer;
      }
    }
  }
  .modal-box {
    @layer daisyui.l1.l2.l3 {
      grid-column-start: 1;
      grid-row-start: 1;
      max-height: 100vh;
      width: calc(11/12 * 100%);
      max-width: 32rem;
      background-color: var(--color-base-100);
      padding: calc(0.25rem * 6);
      transition: translate 0.3s ease-out, scale 0.3s ease-out, opacity 0.2s ease-out 0.05s, box-shadow 0.3s ease-out;
      border-top-left-radius: var(--modal-tl, var(--radius-box));
      border-top-right-radius: var(--modal-tr, var(--radius-box));
      border-bottom-left-radius: var(--modal-bl, var(--radius-box));
      border-bottom-right-radius: var(--modal-br, var(--radius-box));
      scale: 95%;
      opacity: 0;
      box-shadow: oklch(0% 0 0/ 0.25) 0px 25px 50px -12px;
      overflow-y: auto;
      overscroll-behavior: contain;
    }
  }
  .stat-value {
    @layer daisyui.l1.l2.l3 {
      grid-column-start: 1;
      white-space: nowrap;
      font-size: 2rem;
      font-weight: 800;
    }
  }
  .stat-desc {
    @layer daisyui.l1.l2.l3 {
      grid-column-start: 1;
      white-space: nowrap;
      color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-base-content) 60%, transparent);
      }
      font-size: 0.75rem;
    }
  }
  .stat-title {
    @layer daisyui.l1.l2.l3 {
      grid-column-start: 1;
      white-space: nowrap;
      color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-base-content) 60%, transparent);
      }
      font-size: 0.75rem;
    }
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .divider {
    @layer daisyui.l1.l2.l3 {
      display: flex;
      height: calc(0.25rem * 4);
      flex-direction: row;
      align-items: center;
      align-self: stretch;
      white-space: nowrap;
      margin: var(--divider-m, 1rem 0);
      --divider-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        --divider-color: color-mix(in oklab, var(--color-base-content) 10%, transparent);
      }
      &:before, &:after {
        content: "";
        height: calc(0.25rem * 0.5);
        width: 100%;
        flex-grow: 1;
        background-color: var(--divider-color);
      }
      @media print {
        &:before, &:after {
          border: 0.5px solid;
        }
      }
      &:not(:empty) {
        gap: calc(0.25rem * 4);
      }
    }
  }
  .mx-2 {
    margin-inline: calc(var(--spacing) * 2);
  }
  .input-sm {
    @layer daisyui.l1.l2 {
      --size: calc(var(--size-field, 0.25rem) * 8);
      font-size: max(var(--font-size, 0.75rem), 0.75rem);
      &[type="number"] {
        &::-webkit-inner-spin-button {
          margin-block: calc(0.25rem * -2);
          margin-inline-end: calc(0.25rem * -3);
        }
      }
    }
  }
  .my-2 {
    margin-block: calc(var(--spacing) * 2);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-4 {
    margin-block: calc(var(--spacing) * 4);
  }
  .label {
    @layer daisyui.l1.l2.l3 {
      display: inline-flex;
      align-items: center;
      gap: calc(0.25rem * 1.5);
      white-space: nowrap;
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 60%, transparent);
      }
      &:has(input) {
        cursor: pointer;
      }
      &:is(.input > *, .select > *) {
        display: flex;
        height: calc(100% - 0.5rem);
        align-items: center;
        padding-inline: calc(0.25rem * 3);
        white-space: nowrap;
        font-size: inherit;
        &:first-child {
          margin-inline-start: calc(0.25rem * -3);
          margin-inline-end: calc(0.25rem * 3);
          border-inline-end: var(--border) solid currentColor;
          @supports (color: color-mix(in lab, red, red)) {
            border-inline-end: var(--border) solid color-mix(in oklab, currentColor 10%, #0000);
          }
        }
        &:last-child {
          margin-inline-start: calc(0.25rem * 3);
          margin-inline-end: calc(0.25rem * -3);
          border-inline-start: var(--border) solid currentColor;
          @supports (color: color-mix(in lab, red, red)) {
            border-inline-start: var(--border) solid color-mix(in oklab, currentColor 10%, #0000);
          }
        }
      }
    }
  }
  .join-item {
    &:where(*:not(:first-child, :disabled, [disabled], .btn-disabled)) {
      margin-inline-start: calc(var(--border, 1px) * -1);
      margin-block-start: 0;
    }
    &:where(*:is(:disabled, [disabled], .btn-disabled)) {
      border-width: var(--border, 1px) 0 var(--border, 1px) var(--border, 1px);
    }
  }
  .modal-action {
    @layer daisyui.l1.l2.l3 {
      margin-top: calc(0.25rem * 6);
      display: flex;
      justify-content: flex-end;
      gap: calc(0.25rem * 2);
    }
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-4 {
    margin-top: calc(var(--spacing) * 4);
  }
  .mt-6 {
    margin-top: calc(var(--spacing) * 6);
  }
  .mr-1 {
    margin-right: calc(var(--spacing) * 1);
  }
  .mr-2 {
    margin-right: calc(var(--spacing) * 2);
  }
  .mb-0 {
    margin-bottom: calc(var(--spacing) * 0);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-4 {
    margin-bottom: calc(var(--spacing) * 4);
  }
  .mb-6 {
    margin-bottom: calc(var(--spacing) * 6);
  }
  .mb-8 {
    margin-bottom: calc(var(--spacing) * 8);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-3 {
    margin-left: calc(var(--spacing) * 3);
  }
  .status {
    @layer daisyui.l1.l2.l3 {
      display: inline-block;
      aspect-ratio: 1 / 1;
      width: calc(0.25rem * 2);
      height: calc(0.25rem * 2);
      border-radius: var(--radius-selector);
      background-color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        background-color: color-mix(in oklab, var(--color-base-content) 20%, transparent);
      }
      background-position: center;
      background-repeat: no-repeat;
      vertical-align: middle;
      color: color-mix(in srgb, #000 30%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-black) 30%, transparent);
      }
      background-image: radial-gradient( circle at 35% 30%, oklch(1 0 0 / calc(var(--depth) * 0.5)), #0000 );
      box-shadow: 0 2px 3px -1px currentColor;
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 2px 3px -1px color-mix(in oklab, currentColor calc(var(--depth) * 100%), #0000);
      }
    }
  }
  .badge {
    @layer daisyui.l1.l2.l3 {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: calc(0.25rem * 2);
      border-radius: var(--radius-selector);
      vertical-align: middle;
      color: var(--badge-fg);
      border: var(--border) solid var(--badge-color, var(--color-base-200));
      font-size: 0.875rem;
      width: fit-content;
      background-size: auto, calc(var(--noise) * 100%);
      background-image: none, var(--fx-noise);
      background-color: var(--badge-bg);
      --badge-bg: var(--badge-color, var(--color-base-100));
      --badge-fg: var(--color-base-content);
      --size: calc(var(--size-selector, 0.25rem) * 6);
      height: var(--size);
      padding-inline: calc(var(--size) / 2 - var(--border));
    }
  }
  .stat {
    @layer daisyui.l1.l2.l3 {
      display: inline-grid;
      width: 100%;
      column-gap: calc(0.25rem * 4);
      padding-inline: calc(0.25rem * 6);
      padding-block: calc(0.25rem * 4);
      grid-template-columns: repeat(1, 1fr);
      &:not(:last-child) {
        border-inline-end: var(--border) dashed currentColor;
        @supports (color: color-mix(in lab, red, red)) {
          border-inline-end: var(--border) dashed color-mix(in oklab, currentColor 10%, #0000);
        }
        border-block-end: none;
      }
    }
  }
  .card-body {
    @layer daisyui.l1.l2.l3 {
      display: flex;
      flex: auto;
      flex-direction: column;
      gap: calc(0.25rem * 2);
      padding: var(--card-p, 1.5rem);
      font-size: var(--card-fs, 0.875rem);
      :where(p) {
        flex-grow: 1;
      }
    }
  }
  .alert {
    border-width: var(--border);
    border-color: var(--alert-border-color, var(--color-base-200));
    @layer daisyui.l1.l2.l3 {
      border-style: solid;
      --alert-border-color: var(--color-base-200);
      display: grid;
      align-items: center;
      gap: calc(0.25rem * 4);
      border-radius: var(--radius-box);
      padding-inline: calc(0.25rem * 4);
      padding-block: calc(0.25rem * 3);
      color: var(--color-base-content);
      background-color: var(--alert-color, var(--color-base-200));
      justify-content: start;
      justify-items: start;
      grid-auto-flow: column;
      grid-template-columns: auto;
      text-align: start;
      font-size: 0.875rem;
      line-height: 1.25rem;
      background-size: auto, calc(var(--noise) * 100%);
      background-image: none, var(--fx-noise);
      box-shadow: 0 3px 0 -2px oklch(100% 0 0 / calc(var(--depth) * 0.08)) inset, 0 1px #000, 0 4px 3px -2px oklch(0% 0 0 / calc(var(--depth) * 0.08));
      @supports (color: color-mix(in lab, red, red)) {
        box-shadow: 0 3px 0 -2px oklch(100% 0 0 / calc(var(--depth) * 0.08)) inset, 0 1px color-mix( in oklab, color-mix(in oklab, #000 20%, var(--alert-color, var(--color-base-200))) calc(var(--depth) * 20%), #0000 ), 0 4px 3px -2px oklch(0% 0 0 / calc(var(--depth) * 0.08));
      }
      &:has(:nth-child(2)) {
        grid-template-columns: auto minmax(auto, 1fr);
      }
    }
  }
  .card-actions {
    @layer daisyui.l1.l2.l3 {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      gap: calc(0.25rem * 2);
    }
  }
  .card-title {
    @layer daisyui.l1.l2.l3 {
      display: flex;
      align-items: center;
      gap: calc(0.25rem * 2);
      font-size: var(--cardtitle-fs, 1.125rem);
      font-weight: 600;
    }
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .table {
    display: table;
  }
  .btn-circle {
    @layer daisyui.l1.l2 {
      border-radius: calc(infinity * 1px);
      padding-inline: calc(0.25rem * 0);
      width: var(--size);
      height: var(--size);
    }
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-3 {
    height: calc(var(--spacing) * 3);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-5 {
    height: calc(var(--spacing) * 5);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-10 {
    height: calc(var(--spacing) * 10);
  }
  .h-24 {
    height: calc(var(--spacing) * 24);
  }
  .h-64 {
    height: calc(var(--spacing) * 64);
  }
  .h-80 {
    height: calc(var(--spacing) * 80);
  }
  .h-96 {
    height: calc(var(--spacing) * 96);
  }
  .h-\\[300px\\] {
    height: 300px;
  }
  .h-\\[600px\\] {
    height: 600px;
  }
  .h-full {
    height: 100%;
  }
  .h-screen {
    height: 100vh;
  }
  .max-h-40 {
    max-height: calc(var(--spacing) * 40);
  }
  .max-h-56 {
    max-height: calc(var(--spacing) * 56);
  }
  .max-h-96 {
    max-height: calc(var(--spacing) * 96);
  }
  .min-h-screen {
    min-height: 100vh;
  }
  .loading-lg {
    @layer daisyui.l1.l2 {
      width: calc(var(--size-selector, 0.25rem) * 7);
    }
  }
  .loading-md {
    @layer daisyui.l1.l2 {
      width: calc(var(--size-selector, 0.25rem) * 6);
    }
  }
  .loading-sm {
    @layer daisyui.l1.l2 {
      width: calc(var(--size-selector, 0.25rem) * 5);
    }
  }
  .loading-xs {
    @layer daisyui.l1.l2 {
      width: calc(var(--size-selector, 0.25rem) * 4);
    }
  }
  .w-0 {
    width: calc(var(--spacing) * 0);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-5 {
    width: calc(var(--spacing) * 5);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-11\\/12 {
    width: calc(11 / 12 * 100%);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-20 {
    width: calc(var(--spacing) * 20);
  }
  .w-64 {
    width: calc(var(--spacing) * 64);
  }
  .w-72 {
    width: calc(var(--spacing) * 72);
  }
  .w-full {
    width: 100%;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-4xl {
    max-width: var(--container-4xl);
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .flex-1 {
    flex: 1 1;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .table-auto {
    table-layout: auto;
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .link {
    @layer daisyui.l1.l2.l3 {
      cursor: pointer;
      text-decoration-line: underline;
      &:focus {
        --tw-outline-style: none;
        outline-style: none;
        @media (forced-colors: active) {
          outline: 2px solid transparent;
          outline-offset: 2px;
        }
      }
      &:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 2px;
      }
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-6 {
    gap: calc(var(--spacing) * 6);
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-2 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-4 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-6 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-y-8 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .space-x-2 {
    :where(& > :not(:last-child)) {
      --tw-space-x-reverse: 0;
      margin-inline-start: calc(calc(var(--spacing) * 2) * var(--tw-space-x-reverse));
      margin-inline-end: calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-x-reverse)));
    }
  }
  .divide-y {
    :where(& > :not(:last-child)) {
      --tw-divide-y-reverse: 0;
      border-bottom-style: var(--tw-border-style);
      border-top-style: var(--tw-border-style);
      border-top-width: calc(1px * var(--tw-divide-y-reverse));
      border-bottom-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    }
  }
  .divide-red-200 {
    :where(& > :not(:last-child)) {
      border-color: var(--color-red-200);
    }
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .menu-sm {
    @layer daisyui.l1.l2 {
      :where(li:not(.menu-title) > *:not(ul, details, .menu-title)), :where(li:not(.menu-title) > details > summary:not(.menu-title)) {
        border-radius: var(--radius-field);
        padding-inline: calc(0.25rem * 2.5);
        padding-block: calc(0.25rem * 1);
        font-size: 0.75rem;
      }
      .menu-title {
        padding-inline: calc(0.25rem * 3);
        padding-block: calc(0.25rem * 2);
      }
    }
  }
  .rounded-box {
    border-radius: var(--radius-box);
  }
  .rounded-box {
    border-radius: var(--radius-box);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-none {
    border-radius: 0;
  }
  .rounded-r-lg {
    border-top-right-radius: var(--radius-lg);
    border-bottom-right-radius: var(--radius-lg);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-l {
    border-left-style: var(--tw-border-style);
    border-left-width: 1px;
  }
  .badge-ghost {
    @layer daisyui.l1.l2 {
      border-color: var(--color-base-200);
      background-color: var(--color-base-200);
      color: var(--color-base-content);
      background-image: none;
    }
  }
  .badge-outline {
    @layer daisyui.l1.l2 {
      color: var(--badge-color);
      --badge-bg: #0000;
      background-image: none;
      border-color: currentColor;
    }
  }
  .border-amber-400 {
    border-color: var(--color-amber-400);
  }
  .border-base-200 {
    border-color: var(--color-base-200);
  }
  .border-gray-500 {
    border-color: var(--color-gray-500);
  }
  .border-indigo-500 {
    border-color: var(--color-indigo-500);
  }
  .border-orange-400 {
    border-color: var(--color-orange-400);
  }
  .border-orange-500 {
    border-color: var(--color-orange-500);
  }
  .border-pink-400 {
    border-color: var(--color-pink-400);
  }
  .border-pink-500 {
    border-color: var(--color-pink-500);
  }
  .border-primary\\/20 {
    border-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-primary) 20%, transparent);
    }
  }
  .border-purple-500 {
    border-color: var(--color-purple-500);
  }
  .border-red-200 {
    border-color: var(--color-red-200);
  }
  .border-red-400 {
    border-color: var(--color-red-400);
  }
  .border-red-500 {
    border-color: var(--color-red-500);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-yellow-400 {
    border-color: var(--color-yellow-400);
  }
  .table-zebra {
    @layer daisyui.l1.l2 {
      tbody {
        tr {
          &:where(:nth-child(even)) {
            background-color: var(--color-base-200);
            :where(.table-pin-cols tr th) {
              background-color: var(--color-base-200);
            }
          }
          &.row-hover {
            &, &:where(:nth-child(even)) {
              &:hover {
                @media (hover: hover) {
                  background-color: var(--color-base-300);
                }
              }
            }
          }
        }
      }
    }
  }
  .bg-amber-400 {
    background-color: var(--color-amber-400);
  }
  .bg-base-100 {
    background-color: var(--color-base-100);
  }
  .bg-base-200 {
    background-color: var(--color-base-200);
  }
  .bg-blue-50 {
    background-color: var(--color-blue-50);
  }
  .bg-blue-600 {
    background-color: var(--color-blue-600);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-gray-500 {
    background-color: var(--color-gray-500);
  }
  .bg-indigo-500 {
    background-color: var(--color-indigo-500);
  }
  .bg-orange-400 {
    background-color: var(--color-orange-400);
  }
  .bg-orange-500 {
    background-color: var(--color-orange-500);
  }
  .bg-pink-400 {
    background-color: var(--color-pink-400);
  }
  .bg-pink-500 {
    background-color: var(--color-pink-500);
  }
  .bg-primary\\/10 {
    background-color: var(--color-primary);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-primary) 10%, transparent);
    }
  }
  .bg-purple-500 {
    background-color: var(--color-purple-500);
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-400 {
    background-color: var(--color-red-400);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-yellow-400 {
    background-color: var(--color-yellow-400);
  }
  .loading-spinner {
    @layer daisyui.l1.l2 {
      mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }
  }
  .stroke-current {
    stroke: currentcolor;
  }
  .checkbox-sm {
    @layer daisyui.l1.l2 {
      padding: 0.1875rem;
      --size: calc(var(--size-selector, 0.25rem) * 5);
    }
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-4 {
    padding: calc(var(--spacing) * 4);
  }
  .p-8 {
    padding: calc(var(--spacing) * 8);
  }
  .menu-title {
    @layer daisyui.l1.l2.l3 {
      padding-inline: calc(0.25rem * 3);
      padding-block: calc(0.25rem * 2);
      color: var(--color-base-content);
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, var(--color-base-content) 40%, transparent);
      }
      font-size: 0.875rem;
      font-weight: 600;
    }
  }
  .select-sm {
    @layer daisyui.l1.l2 {
      --size: calc(var(--size-field, 0.25rem) * 8);
      font-size: 0.75rem;
      option {
        padding-inline: calc(0.25rem * 2.5);
        padding-block: calc(0.25rem * 1);
      }
    }
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .px-6 {
    padding-inline: calc(var(--spacing) * 6);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .pt-2 {
    padding-top: calc(var(--spacing) * 2);
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-3xl {
    font-size: var(--text-3xl);
    line-height: var(--tw-leading, var(--text-3xl--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .badge-lg {
    @layer daisyui.l1.l2 {
      --size: calc(var(--size-selector, 0.25rem) * 7);
      font-size: 1rem;
    }
  }
  .badge-sm {
    @layer daisyui.l1.l2 {
      --size: calc(var(--size-selector, 0.25rem) * 5);
      font-size: 0.75rem;
    }
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .break-all {
    word-break: break-all;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .alert-error {
    @layer daisyui.l1.l2 {
      color: var(--color-error-content);
      --alert-border-color: var(--color-error);
      --alert-color: var(--color-error);
    }
  }
  .alert-info {
    @layer daisyui.l1.l2 {
      color: var(--color-info-content);
      --alert-border-color: var(--color-info);
      --alert-color: var(--color-info);
    }
  }
  .alert-success {
    @layer daisyui.l1.l2 {
      color: var(--color-success-content);
      --alert-border-color: var(--color-success);
      --alert-color: var(--color-success);
    }
  }
  .alert-warning {
    @layer daisyui.l1.l2 {
      color: var(--color-warning-content);
      --alert-border-color: var(--color-warning);
      --alert-color: var(--color-warning);
    }
  }
  .checkbox-primary {
    @layer daisyui.l1.l2 {
      color: var(--color-primary-content);
      --input-color: var(--color-primary);
    }
  }
  .link-primary {
    @layer daisyui.l1.l2 {
      color: var(--color-primary);
      @media (hover: hover) {
        &:hover {
          color: var(--color-primary);
          @supports (color: color-mix(in lab, red, red)) {
            color: color-mix(in oklab, var(--color-primary) 80%, #000);
          }
        }
      }
    }
  }
  .text-accent {
    color: var(--color-accent);
  }
  .text-amber-900 {
    color: var(--color-amber-900);
  }
  .text-base-content {
    color: var(--color-base-content);
  }
  .text-base-content\\/50 {
    color: var(--color-base-content);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-base-content) 50%, transparent);
    }
  }
  .text-base-content\\/70 {
    color: var(--color-base-content);
    @supports (color: color-mix(in lab, red, red)) {
      color: color-mix(in oklab, var(--color-base-content) 70%, transparent);
    }
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-blue-600 {
    color: var(--color-blue-600);
  }
  .text-cyan-500 {
    color: var(--color-cyan-500);
  }
  .text-error {
    color: var(--color-error);
  }
  .text-gray-100 {
    color: var(--color-gray-100);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-green-500 {
    color: var(--color-green-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-indigo-100 {
    color: var(--color-indigo-100);
  }
  .text-indigo-600 {
    color: var(--color-indigo-600);
  }
  .text-info {
    color: var(--color-info);
  }
  .text-orange-100 {
    color: var(--color-orange-100);
  }
  .text-pink-100 {
    color: var(--color-pink-100);
  }
  .text-primary {
    color: var(--color-primary);
  }
  .text-purple-100 {
    color: var(--color-purple-100);
  }
  .text-red-100 {
    color: var(--color-red-100);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-red-700 {
    color: var(--color-red-700);
  }
  .text-red-800 {
    color: var(--color-red-800);
  }
  .text-success {
    color: var(--color-success);
  }
  .text-warning {
    color: var(--color-warning);
  }
  .text-yellow-900 {
    color: var(--color-yellow-900);
  }
  .link-hover {
    @layer daisyui.l1.l2 {
      text-decoration-line: none;
      &:hover {
        @media (hover: hover) {
          text-decoration-line: underline;
        }
      }
    }
  }
  .opacity-25 {
    opacity: 25%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-75 {
    opacity: 75%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .btn-ghost {
    @layer daisyui.l1 {
      &:not(.btn-active, :hover, :active:focus, :focus-visible, input:checked:not(.filter .btn)) {
        --btn-shadow: "";
        --btn-bg: #0000;
        --btn-border: #0000;
        --btn-noise: none;
        &:not(:disabled, [disabled], .btn-disabled) {
          outline-color: currentcolor;
          --btn-fg: var(--btn-color, currentColor);
        }
      }
      @media (hover: none) {
        &:not(.btn-active, :active, :focus-visible, input:checked:not(.filter .btn)):hover {
          outline-color: currentcolor;
          --btn-shadow: "";
          --btn-bg: #0000;
          --btn-fg: var(--btn-color, currentColor);
          --btn-border: #0000;
          --btn-noise: none;
        }
      }
    }
  }
  .btn-outline {
    @layer daisyui.l1 {
      &:not( .btn-active, :hover, :active:focus, :focus-visible, input:checked:not(.filter .btn), :disabled, [disabled], .btn-disabled ) {
        --btn-shadow: "";
        --btn-bg: #0000;
        --btn-fg: var(--btn-color);
        --btn-border: var(--btn-color);
        --btn-noise: none;
      }
      @media (hover: none) {
        &:not(.btn-active, :active, :focus-visible, input:checked:not(.filter .btn)):hover {
          --btn-shadow: "";
          --btn-bg: #0000;
          --btn-fg: var(--btn-color);
          --btn-border: var(--btn-color);
          --btn-noise: none;
        }
      }
    }
  }
  .btn-sm {
    @layer daisyui.l1.l2 {
      --fontsize: 0.75rem;
      --btn-p: 0.75rem;
      --size: calc(var(--size-field, 0.25rem) * 8);
    }
  }
  .badge-accent {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-accent);
      --badge-fg: var(--color-accent-content);
    }
  }
  .badge-error {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-error);
      --badge-fg: var(--color-error-content);
    }
  }
  .badge-info {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-info);
      --badge-fg: var(--color-info-content);
    }
  }
  .badge-neutral {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-neutral);
      --badge-fg: var(--color-neutral-content);
    }
  }
  .badge-primary {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-primary);
      --badge-fg: var(--color-primary-content);
    }
  }
  .badge-secondary {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-secondary);
      --badge-fg: var(--color-secondary-content);
    }
  }
  .badge-success {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-success);
      --badge-fg: var(--color-success-content);
    }
  }
  .badge-warning {
    @layer daisyui.l1.l2 {
      --badge-color: var(--color-warning);
      --badge-fg: var(--color-warning-content);
    }
  }
  .btn-error {
    @layer daisyui.l1.l2.l3 {
      --btn-color: var(--color-error);
      --btn-fg: var(--color-error-content);
    }
  }
  .btn-info {
    @layer daisyui.l1.l2.l3 {
      --btn-color: var(--color-info);
      --btn-fg: var(--color-info-content);
    }
  }
  .btn-primary {
    @layer daisyui.l1.l2.l3 {
      --btn-color: var(--color-primary);
      --btn-fg: var(--color-primary-content);
    }
  }
  .btn-secondary {
    @layer daisyui.l1.l2.l3 {
      --btn-color: var(--color-secondary);
      --btn-fg: var(--color-secondary-content);
    }
  }
  .btn-success {
    @layer daisyui.l1.l2.l3 {
      --btn-color: var(--color-success);
      --btn-fg: var(--color-success-content);
    }
  }
  .btn-warning {
    @layer daisyui.l1.l2.l3 {
      --btn-color: var(--color-warning);
      --btn-fg: var(--color-warning-content);
    }
  }
  .radio-primary {
    @layer daisyui.l1.l2 {
      --input-color: var(--color-primary);
    }
  }
  .toggle-primary {
    @layer daisyui.l1.l2 {
      &:checked, &[aria-checked="true"] {
        --input-color: var(--color-primary);
      }
    }
  }
  .hover\\:bg-red-100 {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-red-100);
      }
    }
  }
  .hover\\:text-indigo-500 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-indigo-500);
      }
    }
  }
  .hover\\:text-primary\\/80 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-primary);
        @supports (color: color-mix(in lab, red, red)) {
          color: color-mix(in oklab, var(--color-primary) 80%, transparent);
        }
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .focus\\:ring-2 {
    &:focus {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
  }
  .focus\\:ring-primary {
    &:focus {
      --tw-ring-color: var(--color-primary);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .sm\\:grid-cols-2 {
    @media (width >= 40rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .sm\\:flex-row {
    @media (width >= 40rem) {
      flex-direction: row;
    }
  }
  .sm\\:items-center {
    @media (width >= 40rem) {
      align-items: center;
    }
  }
  .md\\:col-span-2 {
    @media (width >= 48rem) {
      grid-column: span 2 / span 2;
    }
  }
  .md\\:grid-cols-2 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-3 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-4 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .md\\:grid-cols-5 {
    @media (width >= 48rem) {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  .md\\:flex-row {
    @media (width >= 48rem) {
      flex-direction: row;
    }
  }
  .md\\:items-center {
    @media (width >= 48rem) {
      align-items: center;
    }
  }
  .md\\:justify-between {
    @media (width >= 48rem) {
      justify-content: space-between;
    }
  }
  .md\\:p-6 {
    @media (width >= 48rem) {
      padding: calc(var(--spacing) * 6);
    }
  }
  .lg\\:col-span-2 {
    @media (width >= 64rem) {
      grid-column: span 2 / span 2;
    }
  }
  .lg\\:grid-cols-2 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-3 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
  .lg\\:grid-cols-4 {
    @media (width >= 64rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .xl\\:grid-cols-4 {
    @media (width >= 80rem) {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
  .xl\\:flex-row {
    @media (width >= 80rem) {
      flex-direction: row;
    }
  }
  .xl\\:items-end {
    @media (width >= 80rem) {
      align-items: flex-end;
    }
  }
  .xl\\:justify-between {
    @media (width >= 80rem) {
      justify-content: space-between;
    }
  }
}
[data-theme="cem-premium"] {
  --color-base-100: #ffffff;
  --color-base-200: #e8eef5;
  --color-base-300: #d7e0ea;
  --color-base-content: #0f172a;
  --color-primary: #123b63;
  --color-primary-content: #f8fafc;
  --color-secondary: #c69214;
  --color-secondary-content: #0f172a;
  --color-accent: #c69214;
  --color-accent-content: #0f172a;
  --color-neutral: #10243d;
  --color-neutral-content: #f8fafc;
  --color-info: #315981;
  --color-info-content: #f8fafc;
  --color-success: #1f7a5a;
  --color-success-content: #f8fafc;
  --color-warning: #c27a0a;
  --color-warning-content: #0f172a;
  --color-error: #b42318;
  --color-error-content: #fef2f2;
  --radius-box: 1rem;
  --radius-field: 0.875rem;
  --radius-selector: 0.875rem;
  --border: 1px;
  --depth: 1;
  --noise: 0;
}
html {
  min-height: 100%;
}
body {
  min-height: 100%;
  margin: 0;
  color: #0f172a;
  font-family: "Manrope", system-ui, sans-serif;
  background: radial-gradient(circle at top right, rgba(198, 146, 20, 0.09), transparent 24rem),
    linear-gradient(180deg, #f8fafc 0%, #f3f6fa 42%, #edf2f7 100%);
}
#root {
  min-height: 100vh;
}
* {
  box-sizing: border-box;
}
::selection {
  background: rgba(18, 59, 99, 0.16);
}
.app-shell {
  position: relative;
}
.app-main {
  padding-top: 1.4rem;
  padding-bottom: 2.75rem;
}
.app-main-auth {
  min-height: 100vh;
}
.page-container {
  width: 100%;
  max-width: 1680px;
  margin-inline: auto;
  padding-inline: 1.1rem;
}
.page-header {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}
.page-eyebrow {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #5b677a;
}
.page-title {
  margin: 0;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: clamp(2rem, 3vw, 2.85rem);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.05em;
  color: #0f172a;
}
.page-subtitle {
  max-width: 62ch;
  margin: 0;
  color: #5b677a;
  font-size: 0.98rem;
  line-height: 1.7;
}
.page-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}
.page-header .btn {
  min-height: 2.72rem;
  padding-inline: 1rem;
  border-radius: 0.82rem;
  font-size: 0.9rem;
  font-weight: 700;
  gap: 0.55rem;
  border-width: 1px;
  box-shadow: none;
}
.page-header .btn.btn-sm {
  min-height: 2.72rem;
  padding-inline: 1rem;
  font-size: 0.9rem;
}
.page-header .btn svg {
  width: 1rem;
  height: 1rem;
  flex: 0 0 auto;
}
.page-header .btn.btn-circle,
.page-header .btn.btn-square {
  width: 2.72rem;
  min-width: 2.72rem;
  padding: 0;
  border-radius: 0.82rem;
}
.page-header .btn-outline,
.page-header .btn-secondary,
.page-header .btn-ghost {
  background: rgba(255, 255, 255, 0.9);
  border-color: #d7e0ea;
  color: #123b63;
}
.page-header .btn-outline:hover,
.page-header .btn-secondary:hover,
.page-header .btn-ghost:hover {
  background: rgba(18, 59, 99, 0.08);
  border-color: rgba(18, 59, 99, 0.18);
  color: #0d2e4e;
}
.page-header .btn-info,
.page-header .btn-success,
.page-header .btn-warning,
.page-header .btn-error {
  box-shadow: 0 18px 36px -30px rgba(15, 23, 42, 0.32);
}
.topbar {
  position: sticky;
  top: 0;
  z-index: 40;
  border-bottom: 1px solid rgba(215, 224, 234, 0.9);
  background: rgba(248, 250, 252, 0.88);
  backdrop-filter: blur(18px);
}
.topbar-shell {
  min-height: 4.45rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-block: 0.55rem;
  min-width: 0;
}
.topbar-section {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-width: 0;
}
.topbar-section:first-child {
  flex: 1 1 auto;
}
.topbar-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: inherit;
  min-width: 0;
  max-width: 100%;
}
.brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.45rem;
  height: 2.45rem;
  border-radius: 0.8rem;
  background: linear-gradient(145deg, #123b63 0%, #0d2e4e 100%);
  color: #f8fafc;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 0.98rem;
  font-weight: 700;
  letter-spacing: -0.06em;
  box-shadow: 0 22px 44px -24px rgba(18, 59, 99, 0.75);
}
.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  min-width: 0;
}
.brand-title {
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.brand-subtitle {
  font-size: 0.67rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b677a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nav-list {
  display: flex;
  align-items: center;
  gap: 0.22rem;
  padding: 0.22rem;
  border: 1px solid #d7e0ea;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 20px 40px -34px rgba(15, 23, 42, 0.36);
}
.topbar-mobile-menu {
  display: inline-flex;
}
.topbar-desktop-nav {
  display: none;
  min-width: 0;
  flex: 1 1 auto;
  justify-content: center;
}
.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.58rem 0.82rem;
  border-radius: 999px;
  color: #5b677a;
  text-decoration: none;
  font-size: 0.87rem;
  font-weight: 700;
  transition: background-color 160ms ease, color 160ms ease, transform 160ms ease;
}
.nav-link:hover {
  color: #123b63;
  background: rgba(18, 59, 99, 0.08);
}
.nav-link-active {
  color: #f8fafc;
  background: linear-gradient(145deg, #123b63 0%, #0d2e4e 100%);
  box-shadow: 0 18px 36px -24px rgba(18, 59, 99, 0.85);
}
.nav-link-icon {
  font-size: 0.92rem;
}
.topbar-user-copy {
  display: none;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.15rem;
}
.topbar-user-label {
  font-size: 0.67rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b677a;
}
.topbar-user-name {
  font-size: 0.88rem;
  font-weight: 700;
}
.user-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.28rem 0.34rem 0.28rem 0.72rem;
  border: 1px solid #d7e0ea;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 18px 36px -30px rgba(15, 23, 42, 0.5);
}
.user-avatar {
  width: 2.15rem;
  height: 2.15rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #123b63 0%, #315981 100%);
  color: #f8fafc;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
}
.dropdown-panel {
  margin-top: 1rem;
  border: 1px solid #d7e0ea;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 28px 60px -38px rgba(15, 23, 42, 0.4);
}
.dropdown-panel .menu-title {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5b677a;
}
.dropdown-link {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  font-weight: 600;
}
.premium-panel,
.card,
.stats,
.table-container {
  border: 1px solid #d7e0ea;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 48px -34px rgba(15, 23, 42, 0.28);
}
.card,
.stats {
  overflow: hidden;
}
.section-card-body,
.card-body {
  padding: 1.5rem;
}
.btn {
  min-height: 2.9rem;
  border-radius: 0.9rem;
  font-weight: 700;
  box-shadow: none;
}
.btn-primary {
  background: linear-gradient(145deg, #123b63 0%, #0d2e4e 100%);
  border-color: #123b63;
  color: #f8fafc;
  box-shadow: 0 22px 44px -28px rgba(18, 59, 99, 0.9);
}
.btn-primary:hover {
  background: linear-gradient(145deg, #0d2e4e 0%, #0b2742 100%);
  border-color: #0d2e4e;
}
.btn-outline,
.btn-ghost,
.btn-secondary {
  border-color: #d7e0ea;
}
.btn-ghost:hover,
.btn-outline:hover {
  background: rgba(18, 59, 99, 0.06);
  color: #123b63;
}
.input,
.select,
.textarea {
  border-color: #d7e0ea;
  background: #ffffff;
  border-radius: 0.9rem;
}
.input:focus,
.select:focus,
.textarea:focus,
.input:focus-visible,
.select:focus-visible,
.textarea:focus-visible {
  outline: none;
  border-color: #315981;
  box-shadow: 0 0 0 4px rgba(18, 59, 99, 0.12);
}
.label-text,
.label-text-alt {
  color: #5b677a;
}
.link,
.link-primary {
  color: #123b63;
  font-weight: 600;
  text-decoration-line: underline;
  text-decoration-thickness: 1.5px;
  text-underline-offset: 0.18em;
  text-decoration-color: rgba(18, 59, 99, 0.38);
  transition: color 160ms ease, text-decoration-color 160ms ease;
}
.link-hover:hover,
.link:hover,
.link-primary:hover {
  color: #0d2e4e;
  text-decoration-color: rgba(13, 46, 78, 0.7);
}
.link:focus-visible,
.link-primary:focus-visible {
  outline: none;
  border-radius: 0.25rem;
  box-shadow: 0 0 0 4px rgba(18, 59, 99, 0.12);
}
.table :where(th, td) {
  border-color: rgba(215, 224, 234, 0.9);
}
.table-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
}
.table-action-btn {
  --table-action-color: #123b63;
  --table-action-bg: rgba(18, 59, 99, 0.07);
  --table-action-border: rgba(18, 59, 99, 0.14);
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.15rem;
  min-width: 2.15rem;
  height: 2.15rem;
  min-height: 2.15rem;
  padding: 0;
  border: 1px solid var(--table-action-border);
  border-radius: 0.72rem;
  background: var(--table-action-bg);
  color: var(--table-action-color);
  text-decoration: none;
  box-shadow: none;
  cursor: pointer;
  transition: transform 160ms ease, background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}
.table-action-btn:hover {
  transform: translateY(-1px);
}
.table-action-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(18, 59, 99, 0.12);
}
.table-action-btn svg {
  width: 1rem;
  height: 1rem;
}
.table-action-btn-neutral {
  --table-action-color: #123b63;
  --table-action-bg: rgba(18, 59, 99, 0.07);
  --table-action-border: rgba(18, 59, 99, 0.14);
}
.table-action-btn-info {
  --table-action-color: #1d4f7a;
  --table-action-bg: rgba(49, 89, 129, 0.1);
  --table-action-border: rgba(49, 89, 129, 0.16);
}
.table-action-btn-success {
  --table-action-color: #1f7a5a;
  --table-action-bg: rgba(31, 122, 90, 0.1);
  --table-action-border: rgba(31, 122, 90, 0.18);
}
.table-action-btn-danger {
  --table-action-color: #b42318;
  --table-action-bg: rgba(180, 35, 24, 0.08);
  --table-action-border: rgba(180, 35, 24, 0.16);
}
.table-action-btn:disabled,
.table-action-btn[aria-disabled="true"] {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}
.table-zebra tbody tr:nth-child(even),
.data-table tbody tr:nth-child(even) {
  background: rgba(232, 238, 245, 0.65);
}
.stat {
  padding: 1.4rem;
}
.stat-title,
.stat-desc {
  color: #5b677a;
}
.stat-value {
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  letter-spacing: -0.05em;
}
.dashboard-hero {
  display: grid;
  gap: 1.25rem;
  padding: 1.6rem;
  border: 1px solid rgba(215, 224, 234, 0.95);
  border-radius: 1.35rem;
  background: linear-gradient(135deg, rgba(18, 59, 99, 0.98) 0%, rgba(13, 46, 78, 0.94) 58%, rgba(198, 146, 20, 0.18) 100%);
  color: #f8fafc;
  box-shadow: 0 28px 55px -34px rgba(15, 23, 42, 0.5);
}
.dashboard-hero .page-title,
.dashboard-hero .page-subtitle,
.dashboard-hero .page-eyebrow {
  color: inherit;
}
.dashboard-hero .page-subtitle {
  opacity: 0.82;
}
.dashboard-hero-grid {
  display: grid;
  gap: 1rem;
}
.context-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.context-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.72rem 0.95rem;
  border-radius: 999px;
  background: rgba(248, 250, 252, 0.12);
  border: 1px solid rgba(248, 250, 252, 0.14);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.context-chip strong {
  color: #f8fafc;
}
.metric-grid {
  display: grid;
  gap: 1rem;
}
.metric-card {
  position: relative;
  overflow: hidden;
  padding: 1.35rem;
}
.metric-card::after {
  content: "";
  position: absolute;
  inset: auto auto 0 0;
  width: 4.5rem;
  height: 0.3rem;
  border-radius: 999px;
  background: linear-gradient(90deg, #123b63 0%, #c69214 100%);
}
.metric-label {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b677a;
}
.metric-value {
  margin-top: 0.9rem;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 700;
  letter-spacing: -0.06em;
  color: #0f172a;
}
.metric-note {
  margin-top: 0.7rem;
  color: #5b677a;
  font-size: 0.92rem;
  line-height: 1.6;
}
.metric-accent {
  color: #123b63;
}
.filter-panel {
  padding: 1.5rem;
}
.panel-header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 1.25rem;
}
.panel-kicker {
  margin: 0;
  color: #5b677a;
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.panel-title {
  margin: 0;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: #0f172a;
}
.panel-subtitle {
  margin: 0;
  color: #5b677a;
  font-size: 0.94rem;
  line-height: 1.6;
}
.chart-panel {
  padding: 1.35rem;
}
.chart-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}
.chart-panel-title {
  margin: 0;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: -0.04em;
}
.chart-panel-copy {
  margin: 0.2rem 0 0;
  color: #5b677a;
  font-size: 0.9rem;
  line-height: 1.6;
}
.sale-detail-shell {
  display: grid;
  gap: 1.5rem;
}
.sale-summary-grid {
  display: grid;
  gap: 1rem;
}
.sale-summary-card {
  padding: 1.25rem;
}
.sale-summary-label {
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5b677a;
}
.sale-summary-value {
  margin-top: 0.55rem;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.04em;
  color: #0f172a;
}
.sale-detail-grid,
.sale-detail-split {
  display: grid;
  gap: 1rem;
}
.sale-detail-section {
  padding: 1.35rem;
}
.sale-detail-list {
  display: grid;
  gap: 0.85rem;
}
.sale-detail-item {
  padding: 0.95rem 1rem;
  border: 1px solid rgba(215, 224, 234, 0.9);
  border-radius: 0.95rem;
  background: rgba(248, 250, 252, 0.58);
}
.sale-detail-label {
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5b677a;
}
.sale-detail-value {
  margin-top: 0.38rem;
  color: #0f172a;
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.55;
}
.sale-detail-value-mono {
  font-family: "IBM Plex Sans", Consolas, monospace;
  font-size: 0.9rem;
  word-break: break-word;
}
.sale-detail-note-box {
  margin-top: 1rem;
  padding: 1rem 1.05rem;
  border-radius: 0.95rem;
  border: 1px solid rgba(194, 122, 10, 0.18);
  background: rgba(194, 122, 10, 0.08);
}
.sale-detail-note-box-info {
  border-color: rgba(49, 89, 129, 0.16);
  background: rgba(49, 89, 129, 0.08);
}
.sale-detail-note-box-title {
  margin-bottom: 0.4rem;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #0f172a;
}
.sale-detail-note-box-copy {
  margin: 0.25rem 0 0;
  color: #334155;
  font-size: 0.9rem;
  line-height: 1.55;
}
.sale-detail-notes {
  min-height: 10rem;
  padding: 1rem 1.05rem;
  border: 1px solid rgba(215, 224, 234, 0.92);
  border-radius: 0.95rem;
  background: rgba(248, 250, 252, 0.58);
  color: #334155;
  line-height: 1.7;
  white-space: pre-wrap;
}
.sale-detail-empty,
.sale-detail-empty-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2rem;
  border-radius: 1rem;
  color: #5b677a;
  text-align: center;
}
.sale-detail-empty-note {
  justify-content: flex-start;
  padding: 1rem 1.05rem;
  border: 1px dashed rgba(215, 224, 234, 0.95);
  background: rgba(248, 250, 252, 0.5);
}
.status-dot {
  display: inline-flex;
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 999px;
}
.login-shell {
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: clamp(1.5rem, 4vw, 3rem);
  background: radial-gradient(circle at top left, rgba(198, 146, 20, 0.13), transparent 22rem),
    radial-gradient(circle at bottom right, rgba(18, 59, 99, 0.12), transparent 26rem),
    linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%);
}
.login-layout {
  width: min(1180px, 100%);
  display: grid;
  gap: 1.5rem;
}
.login-story {
  position: relative;
  overflow: hidden;
  padding: clamp(2rem, 4vw, 3rem);
  border-radius: 1.6rem;
  border: 1px solid rgba(215, 224, 234, 0.9);
  background: linear-gradient(145deg, rgba(18, 59, 99, 0.98) 0%, rgba(13, 46, 78, 0.96) 56%, rgba(49, 89, 129, 0.94) 100%);
  color: #f8fafc;
  box-shadow: 0 36px 80px -46px rgba(15, 23, 42, 0.68);
}
.login-story::before {
  content: "";
  position: absolute;
  inset: auto -3rem -4rem auto;
  width: 18rem;
  height: 18rem;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(198, 146, 20, 0.34) 0%, rgba(198, 146, 20, 0) 70%);
}
.login-story .page-title,
.login-story .page-subtitle,
.login-story .page-eyebrow {
  color: inherit;
}
.login-story-grid {
  display: grid;
  gap: 1rem;
  margin-top: 2rem;
}
.story-card {
  padding: 1rem 1.1rem;
  border-radius: 1rem;
  background: rgba(248, 250, 252, 0.08);
  border: 1px solid rgba(248, 250, 252, 0.12);
}
.story-card-title {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.72;
}
.story-card-copy {
  margin: 0;
  line-height: 1.65;
  opacity: 0.92;
}
.login-form-card {
  align-self: center;
  width: 100%;
  max-width: 28rem;
  margin-inline: auto;
  padding: clamp(1.5rem, 3vw, 2rem);
}
.login-form-card .card-body {
  padding: 0;
}
.login-form-head {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-bottom: 1.5rem;
}
.login-form-title {
  margin: 0;
  font-family: "IBM Plex Sans", "Manrope", system-ui, sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.05em;
}
.login-form-copy {
  margin: 0;
  color: #5b677a;
  font-size: 0.94rem;
  line-height: 1.65;
}
code {
  font-family: "IBM Plex Sans", Consolas, monospace;
}
@media (min-width: 768px) {
  .page-container {
    padding-inline: 1.6rem;
  }
  .sale-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sale-detail-split {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-hero-grid {
    grid-template-columns: minmax(0, 1.6fr) minmax(20rem, 1fr);
    align-items: end;
  }
  .topbar-user-copy {
    display: flex;
  }
  .login-layout {
    grid-template-columns: minmax(0, 1.2fr) minmax(24rem, 0.85fr);
    align-items: stretch;
  }
}
@media (min-width: 1024px) {
  .sale-summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sale-detail-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .metric-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  .topbar-mobile-menu {
    display: none;
  }
  .topbar-desktop-nav {
    display: flex;
  }
}
@media (max-width: 767px) {
  .topbar-shell {
    min-height: 4rem;
    gap: 0.55rem;
  }
  .page-container {
    padding-inline: 0.9rem;
  }
  .topbar-brand {
    gap: 0.55rem;
  }
  .brand-mark {
    width: 2.2rem;
    height: 2.2rem;
  }
  .brand-subtitle {
    display: none;
  }
  .user-trigger {
    padding: 0.2rem;
  }
  .filter-panel,
  .chart-panel,
  .dashboard-hero,
  .metric-card {
    padding: 1.2rem;
  }
}
@layer base {
  :where(:root),:root:has(input.theme-controller[value=winter]:checked),[data-theme=winter] {
    color-scheme: light;
    --color-base-100: oklch(100% 0 0);
    --color-base-200: oklch(97.466% 0.011 259.822);
    --color-base-300: oklch(93.268% 0.016 262.751);
    --color-base-content: oklch(41.886% 0.053 255.824);
    --color-primary: oklch(56.86% 0.255 257.57);
    --color-primary-content: oklch(91.372% 0.051 257.57);
    --color-secondary: oklch(42.551% 0.161 282.339);
    --color-secondary-content: oklch(88.51% 0.032 282.339);
    --color-accent: oklch(59.939% 0.191 335.171);
    --color-accent-content: oklch(11.988% 0.038 335.171);
    --color-neutral: oklch(19.616% 0.063 257.651);
    --color-neutral-content: oklch(83.923% 0.012 257.651);
    --color-info: oklch(88.127% 0.085 214.515);
    --color-info-content: oklch(17.625% 0.017 214.515);
    --color-success: oklch(80.494% 0.077 197.823);
    --color-success-content: oklch(16.098% 0.015 197.823);
    --color-warning: oklch(89.172% 0.045 71.47);
    --color-warning-content: oklch(17.834% 0.009 71.47);
    --color-error: oklch(73.092% 0.11 20.076);
    --color-error-content: oklch(14.618% 0.022 20.076);
    --radius-selector: 1rem;
    --radius-field: 0.5rem;
    --radius-box: 1rem;
    --size-selector: 0.25rem;
    --size-field: 0.25rem;
    --border: 1px;
    --depth: 0;
    --noise: 0;
  }
}
@layer base {
  :root {
    --fx-noise: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
}
@layer base {
  :root {
    scrollbar-color: currentColor #0000;
    @supports (color: color-mix(in lab, red, red)) {
      scrollbar-color: color-mix(in oklch, currentColor 35%, #0000) #0000;
    }
  }
}
@layer base {
  @property --radialprogress {
    syntax: "<percentage>";
    inherits: true;
    initial-value: 0%;
  }
}
@layer base {
  :root:not(span) {
    overflow: var(--page-overflow);
  }
}
@layer base {
  :root {
    background: var(--page-scroll-bg, var(--root-bg));
    --page-scroll-bg-on: linear-gradient(var(--root-bg, #0000), var(--root-bg, #0000))
    var(--root-bg, #0000);
    @supports (color: color-mix(in lab, red, red)) {
      --page-scroll-bg-on: linear-gradient(var(--root-bg, #0000), var(--root-bg, #0000))
    color-mix(in srgb, var(--root-bg, #0000), oklch(0% 0 0) calc(var(--page-has-backdrop, 0) * 40%));
    }
    --page-scroll-transition-on: background-color 0.3s ease-out;
    transition: var(--page-scroll-transition);
    scrollbar-gutter: var(--page-scroll-gutter, unset);
    scrollbar-gutter: if(style(--page-has-scroll: 1): var(--page-scroll-gutter, unset) ; else: unset);
  }
  @keyframes set-page-has-scroll {
    0%, to {
      --page-has-scroll: 1;
    }
  }
}
@layer base {
  :root, [data-theme] {
    background: var(--page-scroll-bg, var(--root-bg));
    color: var(--color-base-content);
  }
  :where(:root, [data-theme]) {
    --root-bg: var(--color-base-100);
  }
}
@keyframes rating {
  0%, 40% {
    scale: 1.1;
    filter: brightness(1.05) contrast(1.05);
  }
}
@keyframes dropdown {
  0% {
    opacity: 0;
  }
}
@keyframes radio {
  0% {
    padding: 5px;
  }
  50% {
    padding: 3px;
  }
}
@keyframes toast {
  0% {
    scale: 0.9;
    opacity: 0;
  }
  100% {
    scale: 1;
    opacity: 1;
  }
}
@keyframes rotator {
  89.9999%, 100% {
    --first-item-position: 0 0%;
  }
  90%, 99.9999% {
    --first-item-position: 0 calc(var(--items) * 100%);
  }
  100% {
    translate: 0 -100%;
  }
}
@keyframes skeleton {
  0% {
    background-position: 150%;
  }
  100% {
    background-position: -50%;
  }
}
@keyframes menu {
  0% {
    opacity: 0;
  }
}
@keyframes progress {
  50% {
    background-position-x: -115%;
  }
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-space-x-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-divide-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-space-y-reverse: 0;
      --tw-space-x-reverse: 0;
      --tw-divide-y-reverse: 0;
      --tw-border-style: solid;
      --tw-font-weight: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/index.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;ICMA,6CAA8C;IDD5C;8BAE0B;IAE1B,wCAAwC;IACxC,0CAA0C;IAC1C,0CAA0C;IAE1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAK1C,6CAA6C;IAG7C,2CAA2C;IAC3C,6CAA6C;IAW7C,4CAA4C;IAK5C,4CAA4C;IAO5C,6CAA6C;IAK7C,6CAA6C;IAoB7C,6CAA6C;IAC7C,6CAA6C;IAmC7C,4CAA4C;IAmB5C,yCAAyC;IAKzC,4CAA4C;IAC5C,4CAA4C;IAO5C,4CAA4C;IAI5C,8CAA8C;IAC9C,8CAA8C;IAmB9C,8CAA8C;IAI9C,4CAA4C;IAoB5C,4CAA4C;IAG5C,4CAA4C;IAC5C,4CAA4C;IAgC5C,4CAA4C;IAC5C,4CAA4C;IAE5C,4CAA4C;IAC5C,4CAA4C;IA2F5C,mBAAmB;IAGnB,kBAAkB;IAYlB,qBAAqB;IAGrB,sBAAsB;IAEtB,sBAAsB;IAKtB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAG1C,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAkB3C,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAoBvB,mBAAmB;IA4CnB,uCAAuC;IAwDvC,uCAAoD;IASpD,4CAAyD;EA5f5C;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IAEE,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IAEd,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA;MAAA,kBAAmB;MAAnB,aAAmB;MAAnB,WAAmB;MAAnB,gBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;cAAnB,iBAAmB;MAAnB,kCAAmB;MAAnB,cAAmB;MAAnB,2BAAmB;MAAnB,+BAAmB;MAAnB;QAAA,sCAAmB;QAAnB,kBAAmB;QAAnB,mBAAmB;QAAnB,wCAAmB;MAAA;MAAnB;QAAA,sCAAmB;QAAnB,kBAAmB;QAAnB,mBAAmB;QAAnB,wCAAmB;QAAnB;UAAA,gBAAmB;UAAnB,gBAAmB;QAAA;MAAA;MAAnB;QAAA,sCAAmB;QAAnB,kBAAmB;QAAnB,mBAAmB;QAAnB;UAAA,eAAmB;UAAnB,eAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA;YAAA,eAAmB;YAAnB,eAAmB;UAAA;QAAA;QAAnB;UAAA;YAAA,gBAAmB;YAAnB,gBAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,kBAAmB;MAAnB,eAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;MAAnB,aAAmB;MAAnB,YAAmB;MAAnB,gBAAmB;MAAnB,WAAmB;MAAnB,eAAmB;MAAnB,mBAAmB;MAAnB,qBAAmB;MAAnB,6BAAmB;MAAnB,0BAAmB;MAAnB,cAAmB;MAAnB,iGAAmB;MAAnB,cAAmB;MAAnB,4BAAmB;MAAnB,YAAmB;MAAnB,sBAAmB;MAAnB;QAAA,aAAmB;MAAA;IAAA;IAAnB;MAAA;QAAA,oBAAmB;QAAnB,mBAAmB;QAAnB,aAAmB;QAAnB,+FAAmB;QAAnB,oCAAmB;QAAnB;UAAA,cAAmB;UAAnB,QAAmB;UAAnB,UAAmB;QAAA;QAAnB;UAAA,sBAAmB;UAAnB,uBAAmB;UAAnB,0CAAmB;UAAnB,4BAAmB;UAAnB,0DAAmB;UAAnB,uCAAmB;UAAnB,4BAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,WAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,qBAAmB;MAAnB,6BAAmB;MAAnB,6BAAmB;MAAnB,qCAAmB;MAAnB;QAAA,kBAAmB;QAAnB,gBAAmB;QAAnB,kCAAmB;QAAnB,iCAAmB;QAAnB,gCAAmB;QAAnB,kBAAmB;QAAnB,mBAAmB;QAAnB,mCAAmB;QAAnB,WAAmB;QAAnB,mBAAmB;QAAnB,iBAAmB;QAAnB,8BAAmB;QAAnB,kBAAmB;QAAnB,oBAAmB;QAAnB,UAAmB;QAAnB,4BAAmB;QAAnB,0BAAmB;MAAA;MAAnB;QAAA,WAAmB;QAAnB,8BAAmB;QAAnB,WAAmB;QAAnB,oBAAmB;QAAnB,eAAmB;QAAnB,eAAmB;QAAnB,cAAmB;QAAnB,kBAAmB;QAAnB,sBAAmB;QAAnB,qBAAmB;QAAnB,uDAAmB;QAAnB,+BAAmB;MAAA;MAAnB;QAAA;UAAA,4GAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA;YAAA,aAAmB;YAAnB,cAAmB;YAAnB;cAAA,wGAAmB;YAAA;UAAA;QAAA;MAAA;IAAA;IAAnB;MAAA;QAAA,8DAAmB;QAAnB,kCAAmB;MAAA;MAAnB;QAAA,8DAAmB;QAAnB,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;MAAnB,kBAAmB;MAAnB,sBAAmB;MAAnB,eAAmB;MAAnB,0BAAmB;MAAnB,8CAAmB;MAAnB,sCAAmB;MAAnB,mBAAmB;MAAnB;QAAA,kBAAmB;QAAnB,sCAAmB;QAAnB,uCAAmB;QAAnB,mBAAmB;QAAnB;UAAA,kBAAmB;UAAnB,qCAAmB;UAAnB,sBAAmB;UAAnB,yBAAmB;UAAnB,2CAAmB;UAAnB,YAAmB;UAAnB,oBAAmB;UAAnB,WAAmB;QAAA;MAAA;MAAnB;QAAA,aAAmB;MAAA;MAAnB;QAAA,aAAmB;QAAnB,sBAAmB;QAAnB,yBAAmB;QAAnB,mBAAmB;QAAnB,sBAAmB;QAAnB,kCAAmB;QAAnB,iCAAmB;QAAnB,kCAAmB;QAAnB,iBAAmB;QAAnB,wDAAmB;QAAnB,yBAAmB;QAAnB,sDAAmB;QAAnB,6DAAmB;QAAnB,kBAAmB;QAAnB,yBAAmB;gBAAnB,iBAAmB;MAAA;MAAnB;QAAA,wBAAmB;QAAnB,mBAAmB;QAAnB;UAAA,8BAAmB;UAAnB,mBAAmB;QAAA;QAAnB;UAAA,aAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,sBAAmB;UAAnB,cAAmB;UAAnB,gBAAmB;UAAnB,eAAmB;UAAnB,eAAmB;UAAnB,iBAAmB;UAAnB,sCAAmB;UAAnB,yBAAmB;UAAnB,WAAmB;UAAnB,yBAAmB;UAAnB,yBAAmB;UAAnB,oBAAmB;QAAA;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,gCAAmB;MAAA;MAAnB;QAAA,aAAmB;QAAnB;UAAA,mCAAmB;UAAnB,mDAAmB;UAAnB,yBAAmB;UAAnB,sDAAmB;QAAA;MAAA;MAAnB;QAAA,gBAAmB;MAAA;MAAnB;QAAA,aAAmB;QAAnB,gBAAmB;MAAA;MAAnB;QAAA;UAAA,eAAmB;UAAnB,2CAAmB;UAAnB;YAAA,iFAAmB;UAAA;UAAnB,gCAAmB;UAAnB,wBAAmB;UAAnB,mBAAmB;UAAnB;YAAA,8BAAmB;YAAnB,mBAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,eAAmB;QAAnB,2CAAmB;QAAnB;UAAA,iFAAmB;QAAA;QAAnB,wBAAmB;QAAnB,mBAAmB;QAAnB;UAAA,8BAAmB;UAAnB,mBAAmB;QAAA;QAAnB,iFAAmB;MAAA;MAAnB;QAAA,2CAAmB;QAAnB,YAAmB;QAAnB,mBAAmB;QAAnB,WAAmB;MAAA;MAAnB;QAAA,kBAAmB;QAAnB,aAAmB;QAAnB,cAAmB;QAAnB,sBAAmB;QAAnB,eAAmB;QAAnB,oBAAmB;QAAnB;UAAA,sBAAmB;QAAA;QAAnB;UAAA,wBAAmB;UAAnB,mBAAmB;UAAnB;YAAA,8BAAmB;YAAnB,mBAAmB;UAAA;UAAnB,4BAAmB;UAAnB,uCAAmB;UAAnB,gDAAmB;UAAnB,uCAAmB;UAAnB;YAAA,qEAAmB;UAAA;QAAA;QAAnB;UAAA,oBAAmB;UAAnB,gCAAmB;UAAnB;YAAA,sEAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA;UAAA,aAAmB;UAAnB,gBAAmB;QAAA;MAAA;MAAnB;QAAA,6BAAmB;QAAnB,0BAAmB;QAAnB;UAAA,aAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,qBAAmB;MAAnB,kEAAmB;MAAnB;QAAA,wBAAmB;QAAnB,mBAAmB;QAAnB;UAAA,8BAAmB;UAAnB,mBAAmB;QAAA;MAAA;MAAnB;QAAA,kBAAmB;MAAA;MAAnB;QAAA,aAAmB;QAAnB,qBAAmB;QAAnB,WAAmB;QAAnB,UAAmB;MAAA;MAAnB;QAAA,YAAmB;QAAnB;UAAA,wBAAmB;UAAnB,4CAAmB;UAAnB,mCAAmB;UAAnB,yBAAmB;UAAnB,wDAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,UAAmB;UAAnB,UAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA;YAAA,oBAAmB;UAAA;UAAnB;YAAA,aAAmB;YAAnB,WAAmB;UAAA;QAAA;QAAnB;UAAA;YAAA,aAAmB;YAAnB,WAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA;UAAA;YAAA,aAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,iBAAmB;MAAA;MAAnB;QAAA,eAAmB;QAAnB,cAAmB;QAAnB;UAAA,YAAmB;UAAnB;YAAA,aAAmB;YAAnB,qBAAmB;YAAnB,WAAmB;YAAnB,UAAmB;UAAA;UAAnB;YAAA,sDAAmB;UAAA;QAAA;QAAnB;UAAA,aAAmB;UAAnB,qBAAmB;UAAnB,WAAmB;UAAnB,UAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;IAAnB;MAAA,0BAAmB;IAAA;IAAnB;MAAA,oBAAmB;MAAnB,cAAmB;MAAnB,eAAmB;MAAnB,iBAAmB;MAAnB,mBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,kBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;cAAnB,iBAAmB;MAAnB,4BAAmB;MAAnB,oBAAmB;MAAnB,+BAAmB;MAAnB,mBAAmB;MAAnB,oCAAmB;MAAnB,gBAAmB;MAAnB,0DAAmB;MAAnB,sEAAmB;MAAnB,sDAAmB;MAAnB,yBAAmB;MAAnB,8DAAmB;MAAnB,4DAAmB;MAAnB,4DAAmB;MAAnB,0DAAmB;MAAnB,+BAAmB;MAAnB,gDAAmB;MAAnB,wCAAmB;MAAnB,2BAAmB;MAAnB,mBAAmB;MAAnB,+BAAmB;MAAnB,gEAAmB;MAAnB,0BAAmB;MAAnB,8FAAmB;MAAnB,6CAAmB;MAAnB,iDAAmB;MAAnB,mCAAmB;MAAnB,aAAmB;MAAnB,2BAAmB;MAAnB;QAAA,8EAAmB;MAAA;MAAnB;kCAAmB;MAAnB;QAAA;uFAAmB;MAAA;MAAnB,4BAAmB;MAAnB;QAAA;UAAA,iDAAmB;UAAnB;YAAA,+EAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,kBAAmB;QAAnB,oBAAmB;QAAnB,kBAAmB;MAAA;MAAnB;QAAA,kBAAmB;QAAnB,iDAAmB;QAAnB;UAAA,+EAAmB;QAAA;QAAnB,qDAAmB;QAAnB;UAAA,mFAAmB;QAAA;QAAnB,8DAAmB;MAAA;MAAnB;QAAA,gBAAmB;QAAnB;UAAA,8BAAmB;UAAnB,0BAAmB;QAAA;MAAA;MAAnB;QAAA,iCAAmB;QAAnB,sCAAmB;QAAnB,kBAAmB;MAAA;IAAA;IAAnB;MAAA;QAAA;UAAA,2CAAmB;UAAnB;YAAA,iFAAmB;UAAA;UAAnB,gBAAmB;QAAA;QAAnB,oBAAmB;QAAnB,mBAAmB;QAAnB,iBAAmB;QAAnB,mCAAmB;QAAnB;UAAA,mEAAmB;QAAA;MAAA;IAAA;IAAnB;MAAA;QAAA;UAAA,2CAAmB;UAAnB;YAAA,iFAAmB;UAAA;UAAnB,gBAAmB;QAAA;QAAnB,oBAAmB;QAAnB,mBAAmB;QAAnB,iBAAmB;QAAnB,mCAAmB;QAAnB;UAAA,mEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,qBAAmB;MAAnB,mBAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,8CAAmB;MAAnB,eAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,mDAAmB;IAAA;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA;MAAA,eAAmB;MAAnB,wBAAmB;MAAnB,mCAAmB;MAAnB,SAAmB;MAAnB,yBAAmB;MAAnB,aAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,6BAAmB;MAAnB,8CAAmB;MAAnB,kBAAmB;MAAnB,6BAAmB;MAAnB;QAAA;UAAA,+BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,oBAAmB;MAAnB,cAAmB;MAAnB,eAAmB;MAAnB,gBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;cAAnB,iBAAmB;MAAnB,kCAAmB;MAAnB;;KAAmB;MAAnB,iJAAmB;MAAnB,wBAAmB;MAAnB,oCAAmB;MAAnB;QAAA,yFAAmB;MAAA;MAAnB,kDAAmB;MAAnB,wCAAmB;MAAnB;QAAA,wEAAmB;MAAA;MAAnB,qCAAmB;MAAnB,+CAAmB;MAAnB,sEAAmB;MAAnB,mBAAmB;MAAnB;QAAA,UAAmB;QAAnB,4BAAmB;QAAnB,oBAAmB;QAAnB,iBAAmB;QAAnB,YAAmB;QAAnB,eAAmB;QAAnB,gBAAmB;QAAnB,6BAAmB;QAAnB,4BAAmB;QAAnB,qCAAmB;QAAnB,YAAmB;QAAnB;UAAA,wBAAmB;UAAnB,mBAAmB;UAAnB;YAAA,8BAAmB;YAAnB,mBAAmB;UAAA;QAAA;QAAnB;UAAA,4BAAmB;UAAnB,YAAmB;QAAA;QAAnB;UAAA,4BAAmB;UAAnB,WAAmB;UAAnB,cAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,WAAmB;UAAnB,aAAmB;QAAA;QAAnB;UAAA,aAAmB;UAAnB,YAAmB;QAAA;MAAA;MAAnB;QAAA,kBAAmB;QAAnB,qCAAmB;QAAnB,oBAAmB;QAAnB,iBAAmB;QAAnB,mBAAmB;QAAnB,YAAmB;QAAnB,WAAmB;QAAnB,qCAAmB;QAAnB,8BAAmB;QAAnB,YAAmB;QAAnB,gBAAmB;QAAnB,0BAAmB;QAAnB,0EAAmB;QAAnB,oJAAmB;QAAnB;UAAA,yMAAmB;QAAA;QAAnB,gDAAmB;QAAnB,uCAAmB;MAAA;MAAnB;QAAA;UAAA,sCAAmB;UAAnB,kBAAmB;UAAnB,8BAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,sBAAmB;UAAnB,qBAAmB;QAAA;MAAA;MAAnB;QAAA,+BAAmB;QAAnB,mBAAmB;MAAA;MAAnB;QAAA,kCAAmB;QAAnB,uCAAmB;QAAnB,wCAAmB;QAAnB;UAAA,8BAAmB;QAAA;QAAnB;UAAA;YAAA,UAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,sCAAmB;MAAA;MAAnB;QAAA,mBAAmB;QAAnB,YAAmB;QAAnB;UAAA,6BAAmB;UAAnB,wCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;MAAnB,iCAAmB;MAAnB,kBAAmB;MAAnB,oBAAmB;MAAnB,cAAmB;MAAnB,gBAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,uCAAmB;MAAnB,iCAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,+BAAmB;MAAnB,mBAAmB;MAAnB,oDAAmB;MAAnB,0BAAmB;MAAnB,8DAAmB;MAAnB,4DAAmB;MAAnB,4DAAmB;MAAnB,0DAAmB;MAAnB,gCAAmB;MAAnB,mGAAmB;MAAnB;QAAA,wJAAmB;MAAA;MAAnB,6CAAmB;MAAnB,wCAAmB;MAAnB;QAAA,wEAAmB;MAAA;MAAnB;QAAA,oBAAmB;MAAA;MAAnB;QAAA,oBAAmB;QAAnB,YAAmB;QAAnB,WAAmB;QAAnB,gBAAmB;QAAnB,6BAAmB;QAAnB,YAAmB;QAAnB;UAAA,wBAAmB;UAAnB,mBAAmB;UAAnB;YAAA,8BAAmB;YAAnB,mBAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,cAAmB;MAAA;MAAnB;QAAA,oBAAmB;MAAA;MAAnB;QAAA,wCAAmB;QAAnB,oCAAmB;QAAnB;UAAA,yFAAmB;QAAA;QAAnB,qCAAmB;QAAnB,mBAAmB;QAAnB,kBAAmB;MAAA;MAAnB;QAAA;UAAA;YAAA,iBAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,mBAAmB;QAAnB,mCAAmB;QAAnB,uCAAmB;QAAnB,gCAAmB;QAAnB;UAAA,sEAAmB;QAAA;QAAnB;UAAA,gCAAmB;UAAnB;YAAA,sEAAmB;UAAA;QAAA;QAAnB,gBAAmB;MAAA;MAAnB;QAAA,mBAAmB;MAAA;MAAnB;QAAA,mBAAmB;MAAA;MAAnB;QAAA;UAAA,gCAAmB;UAAnB,qCAAmB;QAAA;MAAA;MAAnB;QAAA,kBAAmB;QAAnB,wBAAmB;MAAA;MAAnB;QAAA;UAAA,oBAAmB;UAAnB,uBAAmB;UAAnB,gBAAmB;QAAA;QAAnB;UAAA,kBAAmB;UAAnB,wBAAmB;UAAnB,UAAmB;UAAnB,WAAmB;UAAnB,eAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;MAAnB,kBAAmB;MAAnB,WAAmB;MAAnB,yBAAmB;MAAnB,wCAAmB;MAAnB,wCAAmB;MAAnB,qEAAmB;MAAnB,gCAAmB;MAAnB,gBAAmB;MAAnB;QAAA,iBAAmB;MAAA;MAAnB;QAAA;UAAA;YAAA;cAAA,uCAAmB;YAAA;UAAA;QAAA;MAAA;MAAnB;QAAA,iCAAmB;QAAnB,gCAAmB;QAAnB,sBAAmB;MAAA;MAAnB;QAAA,mBAAmB;QAAnB,gCAAmB;QAAnB;UAAA,sEAAmB;QAAA;QAAnB,mBAAmB;QAAnB,gBAAmB;MAAA;MAAnB;QAAA,yDAAmB;QAAnB;UAAA,wFAAmB;QAAA;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,sBAAmB;QAAnB,UAAmB;QAAnB,uCAAmB;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,yBAAmB;QAAnB,UAAmB;QAAnB,uCAAmB;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,wBAAmB;QAAnB,uBAAmB;QAAnB,uCAAmB;MAAA;MAAnB;QAAA,4DAAmB;QAAnB;UAAA,2FAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,kBAAmB;MAAnB,oBAAmB;MAAnB,cAAmB;MAAnB,gBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,uCAAmB;MAAnB,uCAAmB;MAAnB,qCAAmB;MAAnB,sBAAmB;MAAnB,+BAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,0BAAmB;MAAnB,8DAAmB;MAAnB,4DAAmB;MAAnB,4DAAmB;MAAnB,0DAAmB;MAAnB,2HAAmB;MAAnB,2FAAmB;MAAnB,iCAAmB;MAAnB,4BAAmB;MAAnB,mBAAmB;MAAnB,gBAAmB;MAAnB,uBAAmB;MAAnB,mGAAmB;MAAnB;QAAA,wJAAmB;MAAA;MAAnB,gCAAmB;MAAnB,wCAAmB;MAAnB;QAAA,wEAAmB;MAAA;MAAnB,6CAAmB;MAAnB;QAAA,qFAAmB;QAAnB;UAAA,mBAAmB;QAAA;MAAA;MAAnB;QAAA,YAAmB;QAAnB,cAAmB;QAAnB,gCAAmB;QAAnB,qCAAmB;QAAnB,sBAAmB;MAAA;MAAnB;QAAA,uCAAmB;QAAnB,qCAAmB;QAAnB,2BAAmB;QAAnB,gBAAmB;QAAnB,uCAAmB;QAAnB,qCAAmB;QAAnB,4CAAmB;QAAnB,mBAAmB;QAAnB,mBAAmB;QAAnB,sBAAmB;QAAnB,kBAAmB;QAAnB;UAAA,wBAAmB;UAAnB,mBAAmB;UAAnB;YAAA,8BAAmB;YAAnB,mBAAmB;UAAA;QAAA;QAAnB;UAAA,uCAAmB;UAAnB,sBAAmB;QAAA;MAAA;MAAnB;QAAA,wCAAmB;QAAnB,oCAAmB;QAAnB;UAAA,yFAAmB;QAAA;QAAnB,qCAAmB;QAAnB,mBAAmB;QAAnB,kBAAmB;MAAA;MAAnB;QAAA,mBAAmB;QAAnB,mCAAmB;QAAnB,uCAAmB;QAAnB,gCAAmB;QAAnB;UAAA,sEAAmB;QAAA;QAAnB;UAAA,gCAAmB;UAAnB;YAAA,sEAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,mBAAmB;MAAA;MAAnB;QAAA;UAAA,uBAAmB;QAAA;QAAnB;UAAA;YAAA,uBAAmB;UAAA;QAAA;QAAnB;UAAA,cAAmB;UAAnB,6BAAmB;UAAnB,qBAAmB;UAAnB,oBAAmB;UAAnB,iDAAmB;UAAnB,+BAAmB;UAAnB,gCAAmB;UAAnB,0BAAmB;UAAnB,yBAAmB;UAAnB,iEAAmB;UAAnB,yHAAmB;QAAA;QAAnB;UAAA,aAAmB;QAAA;QAAnB;UAAA,kBAAmB;UAAnB;YAAA;cAAA,iBAAmB;YAAA;UAAA;QAAA;QAAnB;UAAA,kCAAmB;UAAnB,iCAAmB;UAAnB,kCAAmB;UAAnB,4CAAmB;UAAnB,yBAAmB;UAAnB,sDAAmB;UAAnB,mBAAmB;UAAnB;YAAA;cAAA,eAAmB;cAAnB,2CAAmB;cAAnB;gBAAA,iFAAmB;cAAA;cAAnB,wBAAmB;cAAnB,mBAAmB;cAAnB;gBAAA,8BAAmB;gBAAnB,mBAAmB;cAAA;YAAA;YAAnB;cAAA,sCAAmB;cAAnB,mCAAmB;cAAnB,oEAAmB;YAAA;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA;MAAA,yEAAmB;MAAnB;QAAA,yGAAmB;MAAA;MAAnB,kBAAmB;MAAnB,qBAAmB;MAAnB,cAAmB;MAAnB,eAAmB;MAAnB,gBAAmB;MAAnB,qCAAmB;MAAnB,0BAAmB;MAAnB,sBAAmB;MAAnB,gCAAmB;MAAnB,4FAAmB;MAAnB,kDAAmB;MAAnB,+CAAmB;MAAnB,kBAAmB;MAAnB,mBAAmB;MAAnB,gDAAmB;MAAnB,uCAAmB;MAAnB;QAAA,gBAAmB;QAAnB,0BAAmB;QAAnB,cAAmB;QAAnB,WAAmB;QAAnB,YAAmB;QAAnB,aAAmB;QAAnB,8BAAmB;QAAnB,WAAmB;QAAnB,qEAAmB;QAAnB,sBAAmB;QAAnB,0EAAmB;QAAnB,0EAAmB;QAAnB,eAAmB;QAAnB,iBAAmB;MAAA;MAAnB;QAAA,mDAAmB;QAAnB,mBAAmB;MAAA;MAAnB;QAAA,2CAAmB;QAAnB,0IAAmB;QAAnB;UAAA,wEAAmB;UAAnB,aAAmB;QAAA;QAAnB;UAAA;YAAA,YAAmB;YAAnB,6BAAmB;YAAnB,kBAAmB;YAAnB,eAAmB;UAAA;QAAA;QAAnB;UAAA;YAAA,YAAmB;YAAnB,6BAAmB;YAAnB,kBAAmB;YAAnB,eAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,iEAAmB;QAAnB;UAAA,iGAAmB;QAAA;QAAnB;UAAA,YAAmB;UAAnB,aAAmB;UAAnB,iBAAmB;UAAnB,0EAAmB;QAAA;MAAA;IAAA;IAAnB;MAAA;QAAA,mBAAmB;QAAnB,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,qBAAmB;MAAnB,cAAmB;MAAnB,eAAmB;MAAnB,gBAAmB;MAAnB,mCAAmB;MAAnB,0BAAmB;MAAnB,sBAAmB;MAAnB,4DAAmB;MAAnB;QAAA,2FAAmB;MAAA;MAAnB,gEAAmB;MAAnB,+CAAmB;MAAnB,kBAAmB;MAAnB,mBAAmB;MAAnB,uCAAmB;MAAnB;QAAA,cAAmB;QAAnB,WAAmB;QAAnB,YAAmB;QAAnB,mCAAmB;QAAnB,gBAAmB;QAAnB,0BAAmB;QAAnB,gDAAmB;QAAnB,uCAAmB;MAAA;MAAnB;QAAA,+BAAmB;MAAA;MAAnB;QAAA,0BAAmB;QAAnB,uCAAmB;QAAnB;UAAA,8BAAmB;QAAA;QAAnB;UAAA,8BAAmB;UAAnB,gLAAmB;QAAA;QAAnB;UAAA;YAAA,sCAAmB;YAAnB,kBAAmB;YAAnB,8BAAmB;UAAA;QAAA;QAAnB;UAAA;YAAA,sBAAmB;YAAnB,qBAAmB;UAAA;QAAA;MAAA;IAAA;IAAnB;MAAA;QAAA,mBAAmB;QAAnB,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,aAAmB;MAAnB,sBAAmB;MAAnB,gCAAmB;MAAnB,kBAAmB;MAAnB,oCAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB;QAAA,wBAAmB;QAAnB,mBAAmB;QAAnB;UAAA,8BAAmB;UAAnB,mBAAmB;QAAA;MAAA;MAAnB;QAAA,2BAAmB;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,kCAAmB;QAAnB,gCAAmB;QAAnB,8BAAmB;QAAnB,4BAAmB;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,gCAAmB;QAAnB,8BAAmB;QAAnB,gCAAmB;QAAnB,8BAAmB;MAAA;MAAnB;QAAA,aAAmB;QAAnB,mBAAmB;QAAnB,uBAAmB;MAAA;MAAnB;QAAA,eAAmB;QAAnB,yBAAmB;gBAAnB,iBAAmB;MAAA;MAAnB;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,oBAAmB;MAAnB,sBAAmB;MAAnB,gBAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,yBAAmB;MAAnB,WAAmB;MAAnB,gBAAmB;MAAnB,gBAAmB;MAAnB,gCAAmB;MAAnB,8BAAmB;MAAnB;QAAA,oEAAmB;MAAA;MAAnB,gCAAmB;MAAnB;QAAA,8GAAmB;QAAnB,qBAAmB;QAAnB,0BAAmB;QAAnB;UAAA,2CAAmB;QAAA;QAAnB;UAAA;YAAA,6BAAmB;YAAnB;cAAA,2CAAmB;cAAnB,8GAAmB;cAAnB,qBAAmB;cAAnB,0BAAmB;YAAA;UAAA;QAAA;MAAA;MAAnB;QAAA;UAAA,gCAAmB;UAAnB,8BAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,gCAAmB;UAAnB,6BAAmB;QAAA;QAAnB;UAAA,gCAAmB;UAAnB,8BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA;MAAA,qBAAmB;MAAnB;QAAA,mCAAmB;QAAnB,cAAmB;QAAnB;UAAA,cAAmB;QAAA;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,oBAAmB;QAAnB;UAAA,SAAmB;UAAnB,yBAAmB;QAAA;MAAA;MAAnB;QAAA,iBAAmB;QAAnB,oBAAmB;QAAnB;UAAA,SAAmB;UAAnB,yBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,oBAAmB;IAAnB,YAAmB;IAAnB,YAAmB;IAAnB,YAAmB;IAAnB,YAAmB;IAAnB;MAAA,4CAAmB;MAAnB,0CAAmB;MAAnB,0CAAmB;MAAnB,wCAAmB;MAAnB;QAAA,8BAAmB;QAAnB,8BAAmB;QAAnB,8BAAmB;QAAnB,8BAAmB;MAAA;IAAA;IAAnB;MAAA,8BAAmB;MAAnB,YAAmB;MAAnB,8BAAmB;MAAnB,YAAmB;IAAA;IAAnB;MAAA;QAAA,8BAAmB;QAAnB,YAAmB;QAAnB,8BAAmB;QAAnB,YAAmB;MAAA;IAAA;IAAnB;MAAA,YAAmB;MAAnB,8BAAmB;MAAnB,YAAmB;MAAnB,8BAAmB;IAAA;IAAnB;MAAA;QAAA,YAAmB;QAAnB,8BAAmB;QAAnB,YAAmB;QAAnB,8BAAmB;MAAA;IAAA;IAAnB;MAAA,8BAAmB;MAAnB,8BAAmB;MAAnB,8BAAmB;MAAnB,8BAAmB;IAAA;IAAnB;MAAA;QAAA,8BAAmB;QAAnB,8BAAmB;QAAnB,8BAAmB;QAAnB,8BAAmB;MAAA;IAAA;IAAnB;MAAA,UAAmB;IAAA;IAAnB;MAAA;QAAA,kBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,eAAmB;MAAnB,eAAmB;MAAnB,iCAAmB;MAAnB,oBAAmB;MAAnB,gBAAmB;MAAnB,mBAAmB;MAAnB,uCAAmB;MAAnB,sBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;cAAnB,iBAAmB;MAAnB,+BAAmB;MAAnB,mBAAmB;MAAnB,2BAAmB;MAAnB,mBAAmB;MAAnB,cAAmB;MAAnB,8DAAmB;MAAnB,4DAAmB;MAAnB,4DAAmB;MAAnB,0DAAmB;MAAnB,gCAAmB;MAAnB,mGAAmB;MAAnB;QAAA,wJAAmB;MAAA;MAAnB,6CAAmB;MAAnB,wCAAmB;MAAnB;QAAA,wEAAmB;MAAA;MAAnB;QAAA,oCAAmB;QAAnB,eAAmB;QAAnB,iCAAmB;QAAnB,wBAAmB;QAAnB,yBAAmB;gBAAnB,iBAAmB;QAAnB,sCAAmB;QAAnB,sCAAmB;QAAnB,6CAAmB;QAAnB,mBAAmB;QAAnB,oBAAmB;QAAnB,2BAAmB;QAAnB,mBAAmB;QAAnB,+BAAmB;QAAnB,oFAAmB;QAAnB,kFAAmB;QAAnB,gBAAmB;QAAnB,+BAAmB;QAAnB,0CAAmB;QAAnB,kCAAmB;QAAnB,6DAAmB;QAAnB,0DAAmB;QAAnB;UAAA,yJAAmB;QAAA;QAAnB,6CAAmB;QAAnB,iDAAmB;QAAnB,mCAAmB;QAAnB,2BAAmB;QAAnB;UAAA,yDAAmB;QAAA;QAAnB;oCAAmB;QAAnB;UAAA;oEAAmB;QAAA;QAAnB,4BAAmB;MAAA;MAAnB;QAAA,wCAAmB;QAAnB,oCAAmB;QAAnB;UAAA,oEAAmB;QAAA;QAAnB,qCAAmB;QAAnB,mBAAmB;QAAnB,kBAAmB;MAAA;MAAnB;QAAA,mBAAmB;QAAnB,mCAAmB;QAAnB,uCAAmB;QAAnB;UAAA,gCAAmB;UAAnB;YAAA,sEAAmB;UAAA;QAAA;QAAnB,gBAAmB;QAAnB,gCAAmB;QAAnB;UAAA,gEAAmB;QAAA;QAAnB;UAAA,mBAAmB;UAAnB,mCAAmB;UAAnB,uCAAmB;UAAnB,mBAAmB;UAAnB,iBAAmB;UAAnB,mCAAmB;UAAnB;YAAA,mEAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,8BAAmB;MAAnB,cAAmB;MAAnB,gBAAmB;MAAnB,kCAAmB;MAAnB,uCAAmB;MAAnB,gCAAmB;MAAnB,sBAAmB;MAAnB,+BAAmB;MAAnB,6BAAmB;MAAnB,2BAAmB;MAAnB,oDAAmB;MAAnB,0BAAmB;MAAnB,gCAAmB;MAAnB,mGAAmB;MAAnB;QAAA,wJAAmB;MAAA;MAAnB,wCAAmB;MAAnB;QAAA,wEAAmB;MAAA;MAAnB;QAAA,gBAAmB;QAAnB,6BAAmB;QAAnB,YAAmB;QAAnB;UAAA,wBAAmB;UAAnB,mBAAmB;UAAnB;YAAA,8BAAmB;YAAnB,mBAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,wCAAmB;QAAnB,oCAAmB;QAAnB;UAAA,yFAAmB;QAAA;QAAnB,qCAAmB;QAAnB,mBAAmB;QAAnB,kBAAmB;MAAA;MAAnB;QAAA;UAAA;YAAA,iBAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA,mBAAmB;QAAnB,mCAAmB;QAAnB,uCAAmB;QAAnB,gCAAmB;QAAnB;UAAA,sEAAmB;QAAA;QAAnB;UAAA,gCAAmB;UAAnB;YAAA,sEAAmB;UAAA;QAAA;QAAnB,gBAAmB;MAAA;MAAnB;QAAA,mBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,iDAAmB;MAAnB;QAAA,+EAAmB;MAAA;MAAnB,8DAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,0CAAmB;MAAnB,uCAAmB;MAAnB;QAAA,YAAmB;QAAnB,WAAmB;QAAnB;UAAA,WAAmB;UAAnB,YAAmB;QAAA;QAAnB;UAAA,UAAmB;UAAnB,YAAmB;QAAA;QAAnB;UAAA,UAAmB;UAAnB,WAAmB;QAAA;MAAA;IAAA;IAAnB;MAAA;QAAA;UAAA,kBAAmB;UAAnB,eAAmB;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA;UAAA,kBAAmB;UAAnB,eAAmB;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA;UAAA,kBAAmB;UAAnB,eAAmB;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;QAAA;MAAA;MAAnB;QAAA;UAAA,kBAAmB;UAAnB,eAAmB;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;UAAnB;YAAA,kBAAmB;YAAnB,eAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,iBAAmB;MAAnB,aAAmB;MAAnB,mBAAmB;MAAnB,qBAAmB;MAAnB,kBAAmB;MAAnB,WAAmB;MAAnB;QAAA,eAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,iBAAmB;MAAnB,iBAAmB;MAAnB,yBAAmB;MAAnB,gBAAmB;MAAnB,uCAAmB;MAAnB,0BAAmB;MAAnB,+GAAmB;MAAnB,0DAAmB;MAAnB,2DAAmB;MAAnB,6DAAmB;MAAnB,8DAAmB;MAAnB,UAAmB;MAAnB,UAAmB;MAAnB,mDAAmB;MAAnB,gBAAmB;MAAnB,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,mBAAmB;MAAnB,eAAmB;MAAnB,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,mBAAmB;MAAnB,gCAAmB;MAAnB;QAAA,sEAAmB;MAAA;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,mBAAmB;MAAnB,gCAAmB;MAAnB;QAAA,sEAAmB;MAAA;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;MAAnB,yBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,gCAAmB;MAAnB,0CAAmB;MAAnB;QAAA,gFAAmB;MAAA;MAAnB;QAAA,WAAmB;QAAnB,2BAAmB;QAAnB,WAAmB;QAAnB,YAAmB;QAAnB,sCAAmB;MAAA;MAAnB;QAAA;UAAA,mBAAmB;QAAA;MAAA;MAAnB;QAAA,sBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,kDAAmB;MAAnB;QAAA;UAAA,gCAAmB;UAAnB,qCAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB;QAAA,yDAAmB;MAAA;MAAnB;QAAA,eAAmB;MAAA;MAAnB;QAAA,aAAmB;QAAnB,2BAAmB;QAAnB,mBAAmB;QAAnB,iCAAmB;QAAnB,mBAAmB;QAAnB,kBAAmB;QAAnB;UAAA,uCAAmB;UAAnB,oCAAmB;UAAnB,mDAAmB;UAAnB;YAAA,mFAAmB;UAAA;QAAA;QAAnB;UAAA,sCAAmB;UAAnB,qCAAmB;UAAnB,qDAAmB;UAAnB;YAAA,qFAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,kDAAmB;MAAnB,qBAAmB;IAAA;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;MAAnB,aAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA;MAAA,qBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;MAAnB,qCAAmB;MAAnB,2CAAmB;MAAnB;QAAA,iFAAmB;MAAA;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MAAnB,gDAAmB;MAAnB;QAAA,+DAAmB;MAAA;MAAnB,sGAAmB;MAAnB,uCAAmB;MAAnB;QAAA,6FAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,mBAAmB;MAAnB,uBAAmB;MAAnB,sBAAmB;MAAnB,qCAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,qEAAmB;MAAnB,mBAAmB;MAAnB,kBAAmB;MAAnB,gDAAmB;MAAnB,uCAAmB;MAAnB,iCAAmB;MAAnB,qDAAmB;MAAnB,qCAAmB;MAAnB,+CAAmB;MAAnB,mBAAmB;MAAnB,qDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;MAAnB,WAAmB;MAAnB,6BAAmB;MAAnB,iCAAmB;MAAnB,gCAAmB;MAAnB,qCAAmB;MAAnB;QAAA,oDAAmB;QAAnB;UAAA,oFAAmB;QAAA;QAAnB,sBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;MAAnB,UAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,8BAAmB;MAAnB,mCAAmB;MAAnB;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,8DAAmB;IAAnB;MAAA,mBAAmB;MAAnB,2CAAmB;MAAnB,aAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,gCAAmB;MAAnB,gCAAmB;MAAnB,2DAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,sBAAmB;MAAnB,2BAAmB;MAAnB,iBAAmB;MAAnB,mBAAmB;MAAnB,oBAAmB;MAAnB,gDAAmB;MAAnB,uCAAmB;MAAnB,gJAAmB;MAAnB;QAAA,2QAAmB;MAAA;MAAnB;QAAA,6CAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;MAAnB,eAAmB;MAAnB,uBAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,aAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,wCAAmB;MAAnB,gBAAmB;IAAA;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,iCAAmB;MAAnB,kBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8CAAmB;IAAA;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA;MAAA,eAAmB;MAAnB,+BAAmB;MAAnB;QAAA,wBAAmB;QAAnB,mBAAmB;QAAnB;UAAA,8BAAmB;UAAnB,mBAAmB;QAAA;MAAA;MAAnB;QAAA,+BAAmB;QAAnB,mBAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,+EAAmB;MAAnB,uFAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,2CAAmB;MAAnB,wCAAmB;MAAnB,wDAAmB;MAAnB,qEAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,kCAAmB;QAAnB,mCAAmB;QAAnB,gCAAmB;QAAnB,kBAAmB;MAAA;MAAnB;QAAA,iCAAmB;QAAnB,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,4CAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,uCAAmB;MAAnB,gCAAmB;MAAnB,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,iBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB;MAAA,wEAAmB;IAAA;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA;UAAA;YAAA,uCAAmB;YAAnB;cAAA,uCAAmB;YAAA;UAAA;UAAnB;YAAA;cAAA;gBAAA;kBAAA,uCAAmB;gBAAA;cAAA;YAAA;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA;MAAA,mDAAmB;IAAA;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA;MAAA,kBAAmB;MAAnB,+CAAmB;IAAA;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,gCAAmB;MAAnB,gCAAmB;MAAnB;QAAA,sEAAmB;MAAA;MAAnB,mBAAmB;MAAnB,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4CAAmB;MAAnB,kBAAmB;MAAnB;QAAA,mCAAmB;QAAnB,gCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,0BAAmB;IAAnB,4DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,eAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+CAAmB;MAAnB,kBAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,wCAAmB;MAAnB,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,uCAAmB;MAAnB,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,0CAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,0CAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2BAAmB;MAAnB;QAAA;UAAA,2BAAmB;UAAnB;YAAA,0DAAmB;UAAA;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,gCAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,wBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB;QAAA;UAAA,+BAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,0HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,gBAAmB;QAAnB,eAAmB;QAAnB,mBAAmB;QAAnB,iBAAmB;QAAnB;UAAA,2BAAmB;UAAnB,wCAAmB;QAAA;MAAA;MAAnB;QAAA;UAAA,2BAAmB;UAAnB,gBAAmB;UAAnB,eAAmB;UAAnB,wCAAmB;UAAnB,mBAAmB;UAAnB,iBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gBAAmB;QAAnB,eAAmB;QAAnB,0BAAmB;QAAnB,8BAAmB;QAAnB,iBAAmB;MAAA;MAAnB;QAAA;UAAA,gBAAmB;UAAnB,eAAmB;UAAnB,0BAAmB;UAAnB,8BAAmB;UAAnB,iBAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;MAAnB,gBAAmB;MAAnB,4CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;MAAnB,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;MAAnB,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;MAAnB,0CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,+BAAmB;MAAnB,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;MAAnB,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;MAAnB,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;MAAnB,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,sCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,8BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;QAAnB;UAAA,iEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wHAAmB;MAAnB,sIAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,4BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gDAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;AADJ;ACj6BjB;EACE,yBAA0B;EAC1B,yBAA0B;EAC1B,yBAA0B;EAC1B,6BAA8B;EAC9B,wBAAyB;EACzB,gCAAiC;EACjC,0BAA2B;EAC3B,kCAAmC;EACnC,uBAAwB;EACxB,+BAAgC;EAChC,wBAAyB;EACzB,gCAAiC;EACjC,qBAAsB;EACtB,6BAA8B;EAC9B,wBAAyB;EACzB,gCAAiC;EACjC,wBAAyB;EACzB,gCAAiC;EACjC,sBAAuB;EACvB,8BAA+B;EAC/B,kBAAmB;EACnB,wBAAyB;EACzB,2BAA4B;EAC5B,aAAc;EACd,UAAW;EACX,UAAW;AACZ;AAED;EACE,gBAAiB;AAClB;AAED;EACE,gBAAiB;EACjB,SAAU;EACV,cAAe;EACf,6CAA8C;EAC9C;kEAEiE;AAClE;AAED;EACE,iBAAkB;AACnB;AAED;EACE,sBAAuB;AACxB;AAED;EACE,kCAAmC;AACpC;AAED;EACE,kBAAmB;AACpB;AAED;EACE,mBAAoB;EACpB,uBAAwB;AACzB;AAED;EACE,iBAAkB;AACnB;AAED;EACE,WAAY;EACZ,iBAAkB;EAClB,mBAAoB;EACpB,sBAAuB;AACxB;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,aAAc;AACf;AAED;EACE,SAAU;EACV,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,SAAU;EACV,8DAA+D;EAC/D,oCAAqC;EACrC,gBAAiB;EACjB,cAAe;EACf,uBAAwB;EACxB,cAAe;AAChB;AAED;EACE,eAAgB;EAChB,SAAU;EACV,cAAe;EACf,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,aAAc;EACd,eAAgB;EAChB,mBAAoB;EACpB,YAAa;AACd;AAED;EACE,mBAAoB;EACpB,oBAAqB;EACrB,sBAAuB;EACvB,iBAAkB;EAClB,gBAAiB;EACjB,YAAa;EACb,iBAAkB;EAClB,gBAAiB;AAClB;AAED;EACE,mBAAoB;EACpB,oBAAqB;EACrB,iBAAkB;AACnB;AAED;EACE,WAAY;EACZ,YAAa;EACb,cAAe;AAChB;AAED;;EAEE,cAAe;EACf,kBAAmB;EACnB,UAAW;EACX,sBAAuB;AACxB;AAED;;;EAGE,oCAAqC;EACrC,qBAAsB;EACtB,cAAe;AAChB;AAED;;;EAGE,kCAAmC;EACnC,oCAAqC;EACrC,cAAe;AAChB;AAED;;;;EAIE,oDAAqD;AACtD;AAED;EACE,gBAAiB;EACjB,MAAO;EACP,WAAY;EACZ,iDAAkD;EAClD,qCAAsC;EACtC,2BAA4B;AAC7B;AAED;EACE,mBAAoB;EACpB,aAAc;EACd,mBAAoB;EACpB,8BAA+B;EAC/B,SAAU;EACV,sBAAuB;EACvB,YAAa;AACd;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,WAAY;EACZ,YAAa;AACd;AAED;EACE,cAAe;AAChB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,YAAa;EACb,qBAAsB;EACtB,cAAe;EACf,YAAa;EACb,eAAgB;AACjB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,cAAe;EACf,eAAgB;EAChB,qBAAsB;EACtB,6DAA8D;EAC9D,cAAe;EACf,8DAA+D;EAC/D,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;EACxB,oDAAqD;AACtD;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,YAAa;EACb,YAAa;AACd;AAED;EACE,8DAA+D;EAC/D,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;EACxB,mBAAoB;EACpB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;EACf,mBAAoB;EACpB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,YAAa;EACb,gBAAiB;EACjB,yBAA0B;EAC1B,oBAAqB;EACrB,qCAAsC;EACtC,oDAAqD;AACtD;AAED;EACE,oBAAqB;AACtB;AAED;EACE,aAAc;EACd,YAAa;EACb,cAAe;EACf,uBAAwB;AACzB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,WAAY;EACZ,wBAAyB;EACzB,oBAAqB;EACrB,cAAe;EACf,qBAAsB;EACtB,kBAAmB;EACnB,gBAAiB;EACjB,+EAAgF;AACjF;AAED;EACE,cAAe;EACf,kCAAmC;AACpC;AAED;EACE,cAAe;EACf,6DAA8D;EAC9D,oDAAqD;AACtD;AAED;EACE,kBAAmB;AACpB;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,qBAAsB;EACtB,YAAa;AACd;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,YAAa;EACb,wCAAyC;EACzC,yBAA0B;EAC1B,oBAAqB;EACrB,qCAAsC;EACtC,mDAAoD;AACrD;AAED;EACE,cAAe;EACf,eAAgB;EAChB,oBAAqB;EACrB,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,6DAA8D;EAC9D,cAAe;EACf,8DAA+D;EAC/D,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,gBAAiB;EACjB,yBAA0B;EAC1B,mBAAoB;EACpB,mBAAoB;EACpB,mDAAoD;AACrD;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,WAAY;EACZ,gBAAiB;AAClB;AAED;;;;EAIE,yBAA0B;EAC1B,mBAAoB;EACpB,qCAAsC;EACtC,oDAAqD;AACtD;AAED;;EAEE,gBAAiB;AAClB;AAED;;EAEE,eAAgB;AACjB;AAED;EACE,kBAAmB;EACnB,qBAAsB;EACtB,gBAAiB;EACjB,gBAAiB;AAClB;AAED;EACE,6DAA8D;EAC9D,qBAAsB;EACtB,cAAe;EACf,mDAAoD;AACrD;AAED;EACE,6DAA8D;EAC9D,qBAAsB;AACvB;AAED;;;EAGE,qBAAsB;AACvB;AAED;;EAEE,kCAAmC;EACnC,cAAe;AAChB;AAED;;;EAGE,qBAAsB;EACtB,mBAAoB;EACpB,qBAAsB;AACvB;AAED;;;;;;EAME,aAAc;EACd,qBAAsB;EACtB,4CAA6C;AAC9C;AAED;;EAEE,cAAe;AAChB;AAED;;EAEE,cAAe;EACf,gBAAiB;EACjB,+BAAgC;EAChC,gCAAiC;EACjC,6BAA8B;EAC9B,6CAA8C;EAC9C,8DAA+D;AAChE;AAED;;;EAGE,cAAe;EACf,4CAA6C;AAC9C;AAED;;EAEE,aAAc;EACd,sBAAuB;EACvB,4CAA6C;AAC9C;AAED;EACE,sCAAuC;AACxC;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,eAAgB;EAChB,YAAa;AACd;AAED;EACE,6BAA8B;EAC9B,yCAA0C;EAC1C,6CAA8C;EAC9C,gBAAiB;EACjB,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,cAAe;EACf,kBAAmB;EACnB,eAAgB;EAChB,mBAAoB;EACpB,UAAW;EACX,4CAA6C;EAC7C,sBAAuB;EACvB,kCAAmC;EACnC,gCAAiC;EACjC,qBAAsB;EACtB,gBAAiB;EACjB,eAAgB;EAChB,wGAAyG;AAC1G;AAED;EACE,2BAA4B;AAC7B;AAED;EACE,aAAc;EACd,4CAA6C;AAC9C;AAED;EACE,WAAY;EACZ,YAAa;AACd;AAED;EACE,6BAA8B;EAC9B,yCAA0C;EAC1C,6CAA8C;AAC/C;AAED;EACE,6BAA8B;EAC9B,yCAA0C;EAC1C,8CAA+C;AAChD;AAED;EACE,6BAA8B;EAC9B,yCAA0C;EAC1C,8CAA+C;AAChD;AAED;EACE,6BAA8B;EAC9B,0CAA2C;EAC3C,8CAA+C;AAChD;AAED;;EAEE,YAAa;EACb,mBAAoB;EACpB,eAAgB;AACjB;AAED;;EAEE,qCAAsC;AACvC;AAED;EACE,eAAgB;AACjB;AAED;;EAEE,cAAe;AAChB;AAED;EACE,8DAA+D;EAC/D,uBAAwB;AACzB;AAED;EACE,aAAc;EACd,YAAa;EACb,eAAgB;EAChB,2CAA4C;EAC5C,sBAAuB;EACvB,yHACgH;EAChH,cAAe;EACf,mDAAoD;AACrD;AAED;;;EAGE,cAAe;AAChB;AAED;EACE,aAAc;AACf;AAED;EACE,aAAc;EACd,SAAU;AACX;AAED;EACE,aAAc;EACd,eAAgB;EAChB,YAAa;AACd;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,WAAY;EACZ,wBAAyB;EACzB,oBAAqB;EACrB,qCAAsC;EACtC,2CAA4C;EAC5C,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;AACxB;AAED;EACE,cAAe;AAChB;AAED;EACE,aAAc;EACd,SAAU;AACX;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,gBAAiB;AAClB;AAED;EACE,WAAY;EACZ,kBAAmB;EACnB,oBAAqB;EACrB,aAAc;EACd,cAAe;EACf,oBAAqB;EACrB,4DAA6D;AAC9D;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,8DAA+D;EAC/D,mCAAoC;EACpC,gBAAiB;EACjB,uBAAwB;EACxB,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,cAAe;EACf,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,cAAe;AAChB;AAED;EACE,eAAgB;AACjB;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,YAAa;EACb,sBAAuB;AACxB;AAED;EACE,SAAU;EACV,cAAe;EACf,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;AAC3B;AAED;EACE,SAAU;EACV,8DAA+D;EAC/D,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;EACxB,cAAe;AAChB;AAED;EACE,SAAU;EACV,cAAe;EACf,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,gBAAiB;AAClB;AAED;EACE,aAAc;EACd,uBAAwB;EACxB,8BAA+B;EAC/B,SAAU;EACV,mBAAoB;AACrB;AAED;EACE,SAAU;EACV,8DAA+D;EAC/D,iBAAkB;EAClB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,kBAAmB;EACnB,cAAe;EACf,iBAAkB;EAClB,gBAAiB;AAClB;AAED;EACE,aAAc;EACd,WAAY;AACb;AAED;EACE,aAAc;EACd,SAAU;AACX;AAED;EACE,gBAAiB;AAClB;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,mBAAoB;EACpB,8DAA+D;EAC/D,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;EACxB,cAAe;AAChB;AAED;;EAEE,aAAc;EACd,SAAU;AACX;AAED;EACE,gBAAiB;AAClB;AAED;EACE,aAAc;EACd,YAAa;AACd;AAED;EACE,qBAAsB;EACtB,0CAA2C;EAC3C,sBAAuB;EACvB,qCAAsC;AACvC;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,mBAAoB;EACpB,cAAe;EACf,kBAAmB;EACnB,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,iDAAkD;EAClD,iBAAkB;EAClB,sBAAuB;AACxB;AAED;EACE,gBAAiB;EACjB,qBAAsB;EACtB,sBAAuB;EACvB,0CAA2C;EAC3C,oCAAqC;AACtC;AAED;EACE,qCAAsC;EACtC,mCAAoC;AACrC;AAED;EACE,qBAAsB;EACtB,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,cAAe;AAChB;AAED;EACE,mBAAoB;EACpB,cAAe;EACf,iBAAkB;EAClB,iBAAkB;AACnB;AAED;EACE,iBAAkB;EAClB,qBAAsB;EACtB,2CAA4C;EAC5C,sBAAuB;EACvB,qCAAsC;EACtC,cAAe;EACf,gBAAiB;EACjB,qBAAsB;AACvB;AAED;;EAEE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,YAAa;EACb,aAAc;EACd,mBAAoB;EACpB,cAAe;EACf,kBAAmB;AACpB;AAED;EACE,2BAA4B;EAC5B,qBAAsB;EACtB,4CAA6C;EAC7C,oCAAqC;AACtC;AAED;EACE,oBAAqB;EACrB,cAAe;EACf,eAAgB;EAChB,oBAAqB;AACtB;AAED;EACE,iBAAkB;EAClB,aAAc;EACd,oBAAqB;EACrB,uBAAwB;EACxB,iCAAkC;EAClC;;qDAGoD;AACrD;AAED;EACE,wBAAyB;EACzB,aAAc;EACd,WAAY;AACb;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,+BAAgC;EAChC,qBAAsB;EACtB,0CAA2C;EAC3C,wHAC+G;EAC/G,cAAe;EACf,oDAAqD;AACtD;AAED;EACE,WAAY;EACZ,kBAAmB;EACnB,4BAA6B;EAC7B,YAAa;EACb,aAAc;EACd,oBAAqB;EACrB,2FAA4F;AAC7F;AAED;;;EAGE,cAAe;AAChB;AAED;EACE,aAAc;EACd,SAAU;EACV,gBAAiB;AAClB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,qCAAsC;EACtC,2CAA4C;AAC7C;AAED;EACE,cAAe;EACf,qBAAsB;EACtB,iBAAkB;EAClB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,aAAc;AACf;AAED;EACE,SAAU;EACV,iBAAkB;EAClB,aAAc;AACf;AAED;EACE,kBAAmB;EACnB,WAAY;EACZ,gBAAiB;EACjB,mBAAoB;EACpB,iCAAkC;AACnC;AAED;EACE,UAAW;AACZ;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,YAAa;EACb,qBAAsB;AACvB;AAED;EACE,SAAU;EACV,8DAA+D;EAC/D,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,SAAU;EACV,cAAe;EACf,kBAAmB;EACnB,iBAAkB;AACnB;AAED;EACE,iDAAkD;AACnD;AAED;EACE;IACE,sBAAuB;EACxB;EAED;IACE,gDAAiD;EAClD;EAED;IACE,gDAAiD;EAClD;EAED;IACE,gDAAiD;EAClD;EAED;IACE,0DAA2D;IAC3D,gBAAiB;EAClB;EAED;IACE,aAAc;EACf;EAED;IACE,6DAA8D;IAC9D,oBAAqB;EACtB;AACF;AAED;EACE;IACE,gDAAiD;EAClD;EAED;IACE,gDAAiD;EAClD;EAED;IACE,gDAAiD;EAClD;AACF;AAED;EACE;IACE,aAAc;EACf;EAED;IACE,aAAc;EACf;AACF;AAED;EACE;IACE,gBAAiB;IACjB,YAAa;EACd;EAED;IACE,sBAAuB;EACxB;EAED;IACE,YAAa;EACd;EAED;IACE,aAAc;IACd,cAAe;EAChB;EAED;IACE,aAAc;EACf;EAED;IACE,eAAgB;EACjB;EAED;;;;IAIE,eAAgB;EACjB;AACF;AA3jCD;EAAA;IAAA,mBAGC;IAHD,iCAGC;IAHD,8CAGC;IAHD,8CAGC;IAHD,kDAGC;IAHD,2CAGC;IAHD,oDAGC;IAHD,+CAGC;IAHD,sDAGC;IAHD,4CAGC;IAHD,oDAGC;IAHD,6CAGC;IAHD,qDAGC;IAHD,0CAGC;IAHD,kDAGC;IAHD,6CAGC;IAHD,qDAGC;IAHD,2CAGC;IAHD,mDAGC;IAHD,yCAGC;IAHD,kDAGC;IAHD,uBAGC;IAHD,sBAGC;IAHD,kBAGC;IAHD,wBAGC;IAHD,qBAGC;IAHD,aAGC;IAHD,UAGC;IAHD,UAGC;EAAA;AAAA;AAHD;EAAA;IAAA,mDAGC;EAAA;AAAA;AAHD;EAAA;IAAA,mCAGC;IAHD;MAAA,mEAGC;IAAA;EAAA;AAAA;AAHD;EAAA;IAAA,sBAGC;IAHD,cAGC;IAHD,iBAGC;EAAA;AAAA;AAHD;EAAA;IAAA,8BAGC;EAAA;AAAA;AAHD;EAAA;IAAA,iDAGC;IAHD;yBAGC;IAHD;MAAA;oGAGC;IAAA;IAHD,2DAGC;IAHD,yCAGC;IAHD,kDAGC;IAHD,iGAGC;EAAA;EAHD;IAAA;MAAA,oBAGC;IAAA;EAAA;AAAA;AAHD;EAAA;IAAA,iDAGC;IAHD,gCAGC;EAAA;EAHD;IAAA,gCAGC;EAAA;AAAA;AAHD;EAAA;IAAA,UAGC;IAHD,uCAGC;EAAA;AAAA;AAHD;EAAA;IAAA,UAGC;EAAA;AAAA;AAHD;EAAA;IAAA,YAGC;EAAA;EAHD;IAAA,YAGC;EAAA;AAAA;AAHD;EAAA;IAAA,UAGC;IAHD,UAGC;EAAA;EAHD;IAAA,QAGC;IAHD,UAGC;EAAA;AAAA;AAHD;EAAA;IAAA,2BAGC;EAAA;EAHD;IAAA,kDAGC;EAAA;EAHD;IAAA,kBAGC;EAAA;AAAA;AAHD;EAAA;IAAA,yBAGC;EAAA;EAHD;IAAA,yBAGC;EAAA;AAAA;AAHD;EAAA;IAAA,UAGC;EAAA;AAAA;AAHD;EAAA;IAAA,4BAGC;EAAA;AAAA;ADw6BC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AA2elB;EAAA;IAAA;MAAA,uBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&display=swap\");\n@import \"tailwindcss\";\n\n@plugin \"daisyui\" {\n  themes: winter --default;\n  logs: true;\n}\n\n@theme {\n  --font-sans: \"Manrope\", system-ui, sans-serif;\n}\n\n[data-theme=\"cem-premium\"] {\n  --color-base-100: #ffffff;\n  --color-base-200: #e8eef5;\n  --color-base-300: #d7e0ea;\n  --color-base-content: #0f172a;\n  --color-primary: #123b63;\n  --color-primary-content: #f8fafc;\n  --color-secondary: #c69214;\n  --color-secondary-content: #0f172a;\n  --color-accent: #c69214;\n  --color-accent-content: #0f172a;\n  --color-neutral: #10243d;\n  --color-neutral-content: #f8fafc;\n  --color-info: #315981;\n  --color-info-content: #f8fafc;\n  --color-success: #1f7a5a;\n  --color-success-content: #f8fafc;\n  --color-warning: #c27a0a;\n  --color-warning-content: #0f172a;\n  --color-error: #b42318;\n  --color-error-content: #fef2f2;\n  --radius-box: 1rem;\n  --radius-field: 0.875rem;\n  --radius-selector: 0.875rem;\n  --border: 1px;\n  --depth: 1;\n  --noise: 0;\n}\n\nhtml {\n  min-height: 100%;\n}\n\nbody {\n  min-height: 100%;\n  margin: 0;\n  color: #0f172a;\n  font-family: \"Manrope\", system-ui, sans-serif;\n  background:\n    radial-gradient(circle at top right, rgba(198, 146, 20, 0.09), transparent 24rem),\n    linear-gradient(180deg, #f8fafc 0%, #f3f6fa 42%, #edf2f7 100%);\n}\n\n#root {\n  min-height: 100vh;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n::selection {\n  background: rgba(18, 59, 99, 0.16);\n}\n\n.app-shell {\n  position: relative;\n}\n\n.app-main {\n  padding-top: 1.4rem;\n  padding-bottom: 2.75rem;\n}\n\n.app-main-auth {\n  min-height: 100vh;\n}\n\n.page-container {\n  width: 100%;\n  max-width: 1680px;\n  margin-inline: auto;\n  padding-inline: 1.1rem;\n}\n\n.page-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.875rem;\n}\n\n.page-eyebrow {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #5b677a;\n}\n\n.page-title {\n  margin: 0;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: clamp(2rem, 3vw, 2.85rem);\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -0.05em;\n  color: #0f172a;\n}\n\n.page-subtitle {\n  max-width: 62ch;\n  margin: 0;\n  color: #5b677a;\n  font-size: 0.98rem;\n  line-height: 1.7;\n}\n\n.page-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.page-header .btn {\n  min-height: 2.72rem;\n  padding-inline: 1rem;\n  border-radius: 0.82rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  gap: 0.55rem;\n  border-width: 1px;\n  box-shadow: none;\n}\n\n.page-header .btn.btn-sm {\n  min-height: 2.72rem;\n  padding-inline: 1rem;\n  font-size: 0.9rem;\n}\n\n.page-header .btn svg {\n  width: 1rem;\n  height: 1rem;\n  flex: 0 0 auto;\n}\n\n.page-header .btn.btn-circle,\n.page-header .btn.btn-square {\n  width: 2.72rem;\n  min-width: 2.72rem;\n  padding: 0;\n  border-radius: 0.82rem;\n}\n\n.page-header .btn-outline,\n.page-header .btn-secondary,\n.page-header .btn-ghost {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: #d7e0ea;\n  color: #123b63;\n}\n\n.page-header .btn-outline:hover,\n.page-header .btn-secondary:hover,\n.page-header .btn-ghost:hover {\n  background: rgba(18, 59, 99, 0.08);\n  border-color: rgba(18, 59, 99, 0.18);\n  color: #0d2e4e;\n}\n\n.page-header .btn-info,\n.page-header .btn-success,\n.page-header .btn-warning,\n.page-header .btn-error {\n  box-shadow: 0 18px 36px -30px rgba(15, 23, 42, 0.32);\n}\n\n.topbar {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  border-bottom: 1px solid rgba(215, 224, 234, 0.9);\n  background: rgba(248, 250, 252, 0.88);\n  backdrop-filter: blur(18px);\n}\n\n.topbar-shell {\n  min-height: 4.45rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-block: 0.55rem;\n  min-width: 0;\n}\n\n.topbar-section {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  min-width: 0;\n}\n\n.topbar-section:first-child {\n  flex: 1 1 auto;\n}\n\n.topbar-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  text-decoration: none;\n  color: inherit;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.brand-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.45rem;\n  height: 2.45rem;\n  border-radius: 0.8rem;\n  background: linear-gradient(145deg, #123b63 0%, #0d2e4e 100%);\n  color: #f8fafc;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 0.98rem;\n  font-weight: 700;\n  letter-spacing: -0.06em;\n  box-shadow: 0 22px 44px -24px rgba(18, 59, 99, 0.75);\n}\n\n.brand-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.18rem;\n  min-width: 0;\n}\n\n.brand-title {\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.brand-subtitle {\n  font-size: 0.67rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5b677a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.nav-list {\n  display: flex;\n  align-items: center;\n  gap: 0.22rem;\n  padding: 0.22rem;\n  border: 1px solid #d7e0ea;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.78);\n  box-shadow: 0 20px 40px -34px rgba(15, 23, 42, 0.36);\n}\n\n.topbar-mobile-menu {\n  display: inline-flex;\n}\n\n.topbar-desktop-nav {\n  display: none;\n  min-width: 0;\n  flex: 1 1 auto;\n  justify-content: center;\n}\n\n.nav-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.58rem 0.82rem;\n  border-radius: 999px;\n  color: #5b677a;\n  text-decoration: none;\n  font-size: 0.87rem;\n  font-weight: 700;\n  transition: background-color 160ms ease, color 160ms ease, transform 160ms ease;\n}\n\n.nav-link:hover {\n  color: #123b63;\n  background: rgba(18, 59, 99, 0.08);\n}\n\n.nav-link-active {\n  color: #f8fafc;\n  background: linear-gradient(145deg, #123b63 0%, #0d2e4e 100%);\n  box-shadow: 0 18px 36px -24px rgba(18, 59, 99, 0.85);\n}\n\n.nav-link-icon {\n  font-size: 0.92rem;\n}\n\n.topbar-user-copy {\n  display: none;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.15rem;\n}\n\n.topbar-user-label {\n  font-size: 0.67rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5b677a;\n}\n\n.topbar-user-name {\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n\n.user-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.28rem 0.34rem 0.28rem 0.72rem;\n  border: 1px solid #d7e0ea;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.85);\n  box-shadow: 0 18px 36px -30px rgba(15, 23, 42, 0.5);\n}\n\n.user-avatar {\n  width: 2.15rem;\n  height: 2.15rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #123b63 0%, #315981 100%);\n  color: #f8fafc;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 0.84rem;\n  font-weight: 700;\n}\n\n.dropdown-panel {\n  margin-top: 1rem;\n  border: 1px solid #d7e0ea;\n  border-radius: 1rem;\n  background: #ffffff;\n  box-shadow: 0 28px 60px -38px rgba(15, 23, 42, 0.4);\n}\n\n.dropdown-panel .menu-title {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #5b677a;\n}\n\n.dropdown-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-weight: 600;\n}\n\n.premium-panel,\n.card,\n.stats,\n.table-container {\n  border: 1px solid #d7e0ea;\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 24px 48px -34px rgba(15, 23, 42, 0.28);\n}\n\n.card,\n.stats {\n  overflow: hidden;\n}\n\n.section-card-body,\n.card-body {\n  padding: 1.5rem;\n}\n\n.btn {\n  min-height: 2.9rem;\n  border-radius: 0.9rem;\n  font-weight: 700;\n  box-shadow: none;\n}\n\n.btn-primary {\n  background: linear-gradient(145deg, #123b63 0%, #0d2e4e 100%);\n  border-color: #123b63;\n  color: #f8fafc;\n  box-shadow: 0 22px 44px -28px rgba(18, 59, 99, 0.9);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(145deg, #0d2e4e 0%, #0b2742 100%);\n  border-color: #0d2e4e;\n}\n\n.btn-outline,\n.btn-ghost,\n.btn-secondary {\n  border-color: #d7e0ea;\n}\n\n.btn-ghost:hover,\n.btn-outline:hover {\n  background: rgba(18, 59, 99, 0.06);\n  color: #123b63;\n}\n\n.input,\n.select,\n.textarea {\n  border-color: #d7e0ea;\n  background: #ffffff;\n  border-radius: 0.9rem;\n}\n\n.input:focus,\n.select:focus,\n.textarea:focus,\n.input:focus-visible,\n.select:focus-visible,\n.textarea:focus-visible {\n  outline: none;\n  border-color: #315981;\n  box-shadow: 0 0 0 4px rgba(18, 59, 99, 0.12);\n}\n\n.label-text,\n.label-text-alt {\n  color: #5b677a;\n}\n\n.link,\n.link-primary {\n  color: #123b63;\n  font-weight: 600;\n  text-decoration-line: underline;\n  text-decoration-thickness: 1.5px;\n  text-underline-offset: 0.18em;\n  text-decoration-color: rgba(18, 59, 99, 0.38);\n  transition: color 160ms ease, text-decoration-color 160ms ease;\n}\n\n.link-hover:hover,\n.link:hover,\n.link-primary:hover {\n  color: #0d2e4e;\n  text-decoration-color: rgba(13, 46, 78, 0.7);\n}\n\n.link:focus-visible,\n.link-primary:focus-visible {\n  outline: none;\n  border-radius: 0.25rem;\n  box-shadow: 0 0 0 4px rgba(18, 59, 99, 0.12);\n}\n\n.table :where(th, td) {\n  border-color: rgba(215, 224, 234, 0.9);\n}\n\n.table-actions {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.table-action-btn {\n  --table-action-color: #123b63;\n  --table-action-bg: rgba(18, 59, 99, 0.07);\n  --table-action-border: rgba(18, 59, 99, 0.14);\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.15rem;\n  min-width: 2.15rem;\n  height: 2.15rem;\n  min-height: 2.15rem;\n  padding: 0;\n  border: 1px solid var(--table-action-border);\n  border-radius: 0.72rem;\n  background: var(--table-action-bg);\n  color: var(--table-action-color);\n  text-decoration: none;\n  box-shadow: none;\n  cursor: pointer;\n  transition: transform 160ms ease, background-color 160ms ease, border-color 160ms ease, color 160ms ease;\n}\n\n.table-action-btn:hover {\n  transform: translateY(-1px);\n}\n\n.table-action-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(18, 59, 99, 0.12);\n}\n\n.table-action-btn svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.table-action-btn-neutral {\n  --table-action-color: #123b63;\n  --table-action-bg: rgba(18, 59, 99, 0.07);\n  --table-action-border: rgba(18, 59, 99, 0.14);\n}\n\n.table-action-btn-info {\n  --table-action-color: #1d4f7a;\n  --table-action-bg: rgba(49, 89, 129, 0.1);\n  --table-action-border: rgba(49, 89, 129, 0.16);\n}\n\n.table-action-btn-success {\n  --table-action-color: #1f7a5a;\n  --table-action-bg: rgba(31, 122, 90, 0.1);\n  --table-action-border: rgba(31, 122, 90, 0.18);\n}\n\n.table-action-btn-danger {\n  --table-action-color: #b42318;\n  --table-action-bg: rgba(180, 35, 24, 0.08);\n  --table-action-border: rgba(180, 35, 24, 0.16);\n}\n\n.table-action-btn:disabled,\n.table-action-btn[aria-disabled=\"true\"] {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.table-zebra tbody tr:nth-child(even),\n.data-table tbody tr:nth-child(even) {\n  background: rgba(232, 238, 245, 0.65);\n}\n\n.stat {\n  padding: 1.4rem;\n}\n\n.stat-title,\n.stat-desc {\n  color: #5b677a;\n}\n\n.stat-value {\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  letter-spacing: -0.05em;\n}\n\n.dashboard-hero {\n  display: grid;\n  gap: 1.25rem;\n  padding: 1.6rem;\n  border: 1px solid rgba(215, 224, 234, 0.95);\n  border-radius: 1.35rem;\n  background:\n    linear-gradient(135deg, rgba(18, 59, 99, 0.98) 0%, rgba(13, 46, 78, 0.94) 58%, rgba(198, 146, 20, 0.18) 100%);\n  color: #f8fafc;\n  box-shadow: 0 28px 55px -34px rgba(15, 23, 42, 0.5);\n}\n\n.dashboard-hero .page-title,\n.dashboard-hero .page-subtitle,\n.dashboard-hero .page-eyebrow {\n  color: inherit;\n}\n\n.dashboard-hero .page-subtitle {\n  opacity: 0.82;\n}\n\n.dashboard-hero-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.context-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.context-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.72rem 0.95rem;\n  border-radius: 999px;\n  background: rgba(248, 250, 252, 0.12);\n  border: 1px solid rgba(248, 250, 252, 0.14);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.context-chip strong {\n  color: #f8fafc;\n}\n\n.metric-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.metric-card {\n  position: relative;\n  overflow: hidden;\n  padding: 1.35rem;\n}\n\n.metric-card::after {\n  content: \"\";\n  position: absolute;\n  inset: auto auto 0 0;\n  width: 4.5rem;\n  height: 0.3rem;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #123b63 0%, #c69214 100%);\n}\n\n.metric-label {\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5b677a;\n}\n\n.metric-value {\n  margin-top: 0.9rem;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: clamp(2rem, 4vw, 2.8rem);\n  font-weight: 700;\n  letter-spacing: -0.06em;\n  color: #0f172a;\n}\n\n.metric-note {\n  margin-top: 0.7rem;\n  color: #5b677a;\n  font-size: 0.92rem;\n  line-height: 1.6;\n}\n\n.metric-accent {\n  color: #123b63;\n}\n\n.filter-panel {\n  padding: 1.5rem;\n}\n\n.panel-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-bottom: 1.25rem;\n}\n\n.panel-kicker {\n  margin: 0;\n  color: #5b677a;\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.panel-title {\n  margin: 0;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.04em;\n  color: #0f172a;\n}\n\n.panel-subtitle {\n  margin: 0;\n  color: #5b677a;\n  font-size: 0.94rem;\n  line-height: 1.6;\n}\n\n.chart-panel {\n  padding: 1.35rem;\n}\n\n.chart-panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.chart-panel-title {\n  margin: 0;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 1.2rem;\n  font-weight: 700;\n  letter-spacing: -0.04em;\n}\n\n.chart-panel-copy {\n  margin: 0.2rem 0 0;\n  color: #5b677a;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.sale-detail-shell {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.sale-summary-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.sale-summary-card {\n  padding: 1.25rem;\n}\n\n.sale-summary-label {\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #5b677a;\n}\n\n.sale-summary-value {\n  margin-top: 0.55rem;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.04em;\n  color: #0f172a;\n}\n\n.sale-detail-grid,\n.sale-detail-split {\n  display: grid;\n  gap: 1rem;\n}\n\n.sale-detail-section {\n  padding: 1.35rem;\n}\n\n.sale-detail-list {\n  display: grid;\n  gap: 0.85rem;\n}\n\n.sale-detail-item {\n  padding: 0.95rem 1rem;\n  border: 1px solid rgba(215, 224, 234, 0.9);\n  border-radius: 0.95rem;\n  background: rgba(248, 250, 252, 0.58);\n}\n\n.sale-detail-label {\n  font-size: 0.74rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #5b677a;\n}\n\n.sale-detail-value {\n  margin-top: 0.38rem;\n  color: #0f172a;\n  font-size: 0.98rem;\n  font-weight: 600;\n  line-height: 1.55;\n}\n\n.sale-detail-value-mono {\n  font-family: \"IBM Plex Sans\", Consolas, monospace;\n  font-size: 0.9rem;\n  word-break: break-word;\n}\n\n.sale-detail-note-box {\n  margin-top: 1rem;\n  padding: 1rem 1.05rem;\n  border-radius: 0.95rem;\n  border: 1px solid rgba(194, 122, 10, 0.18);\n  background: rgba(194, 122, 10, 0.08);\n}\n\n.sale-detail-note-box-info {\n  border-color: rgba(49, 89, 129, 0.16);\n  background: rgba(49, 89, 129, 0.08);\n}\n\n.sale-detail-note-box-title {\n  margin-bottom: 0.4rem;\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #0f172a;\n}\n\n.sale-detail-note-box-copy {\n  margin: 0.25rem 0 0;\n  color: #334155;\n  font-size: 0.9rem;\n  line-height: 1.55;\n}\n\n.sale-detail-notes {\n  min-height: 10rem;\n  padding: 1rem 1.05rem;\n  border: 1px solid rgba(215, 224, 234, 0.92);\n  border-radius: 0.95rem;\n  background: rgba(248, 250, 252, 0.58);\n  color: #334155;\n  line-height: 1.7;\n  white-space: pre-wrap;\n}\n\n.sale-detail-empty,\n.sale-detail-empty-note {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 2rem;\n  border-radius: 1rem;\n  color: #5b677a;\n  text-align: center;\n}\n\n.sale-detail-empty-note {\n  justify-content: flex-start;\n  padding: 1rem 1.05rem;\n  border: 1px dashed rgba(215, 224, 234, 0.95);\n  background: rgba(248, 250, 252, 0.5);\n}\n\n.status-dot {\n  display: inline-flex;\n  width: 0.65rem;\n  height: 0.65rem;\n  border-radius: 999px;\n}\n\n.login-shell {\n  min-height: 100vh;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  padding: clamp(1.5rem, 4vw, 3rem);\n  background:\n    radial-gradient(circle at top left, rgba(198, 146, 20, 0.13), transparent 22rem),\n    radial-gradient(circle at bottom right, rgba(18, 59, 99, 0.12), transparent 26rem),\n    linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%);\n}\n\n.login-layout {\n  width: min(1180px, 100%);\n  display: grid;\n  gap: 1.5rem;\n}\n\n.login-story {\n  position: relative;\n  overflow: hidden;\n  padding: clamp(2rem, 4vw, 3rem);\n  border-radius: 1.6rem;\n  border: 1px solid rgba(215, 224, 234, 0.9);\n  background:\n    linear-gradient(145deg, rgba(18, 59, 99, 0.98) 0%, rgba(13, 46, 78, 0.96) 56%, rgba(49, 89, 129, 0.94) 100%);\n  color: #f8fafc;\n  box-shadow: 0 36px 80px -46px rgba(15, 23, 42, 0.68);\n}\n\n.login-story::before {\n  content: \"\";\n  position: absolute;\n  inset: auto -3rem -4rem auto;\n  width: 18rem;\n  height: 18rem;\n  border-radius: 999px;\n  background: radial-gradient(circle, rgba(198, 146, 20, 0.34) 0%, rgba(198, 146, 20, 0) 70%);\n}\n\n.login-story .page-title,\n.login-story .page-subtitle,\n.login-story .page-eyebrow {\n  color: inherit;\n}\n\n.login-story-grid {\n  display: grid;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.story-card {\n  padding: 1rem 1.1rem;\n  border-radius: 1rem;\n  background: rgba(248, 250, 252, 0.08);\n  border: 1px solid rgba(248, 250, 252, 0.12);\n}\n\n.story-card-title {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  opacity: 0.72;\n}\n\n.story-card-copy {\n  margin: 0;\n  line-height: 1.65;\n  opacity: 0.92;\n}\n\n.login-form-card {\n  align-self: center;\n  width: 100%;\n  max-width: 28rem;\n  margin-inline: auto;\n  padding: clamp(1.5rem, 3vw, 2rem);\n}\n\n.login-form-card .card-body {\n  padding: 0;\n}\n\n.login-form-head {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin-bottom: 1.5rem;\n}\n\n.login-form-title {\n  margin: 0;\n  font-family: \"IBM Plex Sans\", \"Manrope\", system-ui, sans-serif;\n  font-size: 1.75rem;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n}\n\n.login-form-copy {\n  margin: 0;\n  color: #5b677a;\n  font-size: 0.94rem;\n  line-height: 1.65;\n}\n\ncode {\n  font-family: \"IBM Plex Sans\", Consolas, monospace;\n}\n\n@media (min-width: 768px) {\n  .page-container {\n    padding-inline: 1.6rem;\n  }\n\n  .sale-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .sale-detail-split {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .metric-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .dashboard-hero-grid {\n    grid-template-columns: minmax(0, 1.6fr) minmax(20rem, 1fr);\n    align-items: end;\n  }\n\n  .topbar-user-copy {\n    display: flex;\n  }\n\n  .login-layout {\n    grid-template-columns: minmax(0, 1.2fr) minmax(24rem, 0.85fr);\n    align-items: stretch;\n  }\n}\n\n@media (min-width: 1024px) {\n  .sale-summary-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .sale-detail-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .metric-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1280px) {\n  .topbar-mobile-menu {\n    display: none;\n  }\n\n  .topbar-desktop-nav {\n    display: flex;\n  }\n}\n\n@media (max-width: 767px) {\n  .topbar-shell {\n    min-height: 4rem;\n    gap: 0.55rem;\n  }\n\n  .page-container {\n    padding-inline: 0.9rem;\n  }\n\n  .topbar-brand {\n    gap: 0.55rem;\n  }\n\n  .brand-mark {\n    width: 2.2rem;\n    height: 2.2rem;\n  }\n\n  .brand-subtitle {\n    display: none;\n  }\n\n  .user-trigger {\n    padding: 0.2rem;\n  }\n\n  .filter-panel,\n  .chart-panel,\n  .dashboard-hero,\n  .metric-card {\n    padding: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
